import { getController, postController } from '@/controllers/request.js';
import {
  ACTION,
  BUTTON,
  EVENTBUS_EVENTS,
  FIELD,
  INTENT_AREA,
  MODULE,
  SCROLL_VALUE
} from '@/utils/constants';
import { scrollToError, setContactData } from '@/utils/helpers';
import { Message, Notification } from 'element-ui';
import isPlainObject from 'lodash/isPlainObject';

import { eventBus } from '@/bus';
import { store } from '@/store';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const dialogMixin = {
  methods: {
    setVisibleDialog(name, val) {
      // учесть разные модули стор
      store.commit('common/setVisibleDialog', { name, val });
    }
  }
};

export const parseIntent = {
  computed: {
    getIntents() {
      return store.state.event.intents;
    },
    getIsDoneAsync() {
      return store.state.event.asyncIntentsDone;
    }
  },
  methods: {
    getHiddenStagesFromIntent(intent) {
      const hiddenStages = [];
      if (intent.request.url.includes('hidden_stage_ids[]')) {
        const parsedUrlItems = intent.request.url.split('&');
        parsedUrlItems.forEach(item => {
          if (item.includes('hidden_stage_ids[]')) {
            hiddenStages.push(item.split('=')[1]);
          }
        });
      }
      return hiddenStages;
    },

    goToOldPage(item) {
      let url = item.request.url;

      if (item.request.request_params) {
        Object.keys(item.request.request_params).forEach(param => {
          url += `&${param}=${item.request.request_params[param]}`;
        });
      }
      const route = this.$router.resolve({
        name: '*',
        params: {
          url
        }
      });
      window.open(route.href, '_blank');
    },

    async parse() {
      const handleUserCardNotification = (type, url, resp) => {
        if (url.includes('action=Save') && type == 'change_status') {
          eventBus.$emit(EVENTBUS_EVENTS.CHANGE_USER_STATUS, resp);
        } else if (url.includes('action=Save') && !type) {
          eventBus.$emit(
            EVENTBUS_EVENTS.ROLES_EDIT,
            resp?.data?.status != 'error',
            resp?.data?.status == 'error'
              ? resp?.data?.error?.error_text?.error ||
                  resp?.data?.error?.error_text
              : ''
          );
        } else if (
          url.includes('action=Save') &&
          type == 'change_password' &&
          resp
        ) {
          eventBus.$emit(EVENTBUS_EVENTS.CHANGE_USER_PASSWORD, resp);
        }
      };

      const intents = [...this.getIntents];

      for (const intent of intents) {
        if (
          intent.intentArea === INTENT_AREA.SAVE &&
          (this.form?.action == 'generateFileResumePDF' ||
            this.form?.action == 'generateFileResumeDOCX' ||
            intent.request.request_params.action ==
              'mass_selection_stage_ajax' ||
            this.isEmailForm)
        ) {
          let errorFields = this.getErrorValidFields(this.$refs.form);
          if (this.isEmailForm && this.files.length) {
            let newFiles = [...this.files];
            newFiles.forEach(file => {
              if (file.type == 'template' || file.type == 'forward') {
                this.form.template_attachment = this.form.template_attachment
                  ? [...this.form.template_attachment, file.id]
                  : [file.id];
              } else if (file.type == 'removed') {
                this.form.temp_remove_attachment = this.form
                  .temp_remove_attachment
                  ? [...this.form.temp_remove_attachment, file.id]
                  : [file.id];
              } else {
                this.form.email_attachment = this.form.email_attachment
                  ? [...this.form.email_attachment, file.raw]
                  : [file.raw];
              }
            });
          }
          if (!errorFields.length) {
            if (this.isEmailForm) {
              eventBus.$emit(EVENTBUS_EVENTS.EMAIL_SENT, true);
            }
            const resp = await this.sendFormRequestFromIntent(
              intent,
              this.form
            );
            if (resp.data?.errors?.length) {
              eventBus.$emit(EVENTBUS_EVENTS.FORM_ERROR);
              break;
            } else if (resp.data?.successfully) {
              eventBus.$emit(
                EVENTBUS_EVENTS.SHOW_SUCCESS,
                resp.data?.successfully
              );
            } else if (resp.data?.unsuccessfully) {
              eventBus.$emit(
                EVENTBUS_EVENTS.SHOW_ERROR,
                resp.data?.unsuccessfully
              );
            } else {
              if (
                resp.data?.status &&
                resp.data?.status == 'ok' &&
                resp.data?.message
              ) {
                errorMsg.methods.showNotification({
                  showClose: true,
                  message: resp.data?.message,
                  type: 'success'
                });
              } else if (
                resp.data?.status &&
                resp.data?.status == 'error' &&
                resp.data.errors?.title
              ) {
                errorMsg.methods.showNotification({
                  showClose: true,
                  message: resp.data.errors?.title,
                  type: 'error'
                });
              }
              eventBus.$emit(EVENTBUS_EVENTS.DOWNLOAD_FILE, resp.data);
            }
          } else break;
        } else if (intent.intentArea === INTENT_AREA.OUTER_PAGE) {
          window.open(
            intent.request.url,
            intent.request?.request_params?.targetBlank === true
              ? '_blank'
              : '_self'
          );
        } else if (intent.intentArea === INTENT_AREA.SAVE) {
          this.defaultParams = {
            module: intent.request.request_params.module || this.module,
            action: intent.request.request_params.action || 'Save',
            ...intent.request.request_params,
            ...this.defaultParams
          };
          const resp = await this.saveForm();
          if (!resp) {
            eventBus.$emit(EVENTBUS_EVENTS.FORM_ERROR);
            break;
          } else {
            if (
              this.$route?.meta?.module == MODULE.USERS &&
              this.$route?.params?.id
            ) {
              handleUserCardNotification(intent.type, intent.request.url, resp);
            } else if (
              intent?.request?.request_params?.action == ACTION.EVENT_SAVE
            ) {
              eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, 'events');
            } else if (this.isClosePositionPopup || this.isOpenPositionPopup) {
              eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, 'description');
            }
          }
        } else if (intent.intentArea === INTENT_AREA.SEND_REQUEST) {
          if (!intent.request.url.includes(MODULE.CANDIDATE_RESPONDS)) {
            const response = await mixin.methods.sendFormRequestFromIntent(
              intent
            );
            eventBus.$emit(intent.intentArea, response);
          } else {
            eventBus.$emit(intent.intentArea, intent);
          }
        } else if (intent.intentArea === INTENT_AREA.CHECK_ACCESS) {
          const response = await mixin.methods.sendFormRequestFromIntent(
            intent
          );

          eventBus.$emit(intent.intentArea, response);
          if (response?.data?.status == 'error') {
            store.commit('event/setRemoveIntentsAll');
            break;
          }
        } else if (intent.intentArea === INTENT_AREA.POPUP) {
          const response = await this.sendFormRequestFromIntent(intent);
          store.commit('dialog/setMetadataDialog', response.data.metadata);
          // store.commit('dialog/setSize', intents[index].size);
          store.commit('dialog/setBeanDialog', response.data.bean);
          store.commit('dialog/setVisibleSingleDialog', true);
        } else if (intent.intentArea == INTENT_AREA.RELOAD_TAB) {
          if (intent.request?.request_params?.tab_id == 'candidates') {
            store.commit('vacancy/setParam', {
              name: 'currentVacancyCandidate',
              val: null
            });
            store.commit('rightPanel/setParam', {
              name: 'panelMode',
              val: null
            });
          }
          eventBus.$emit(
            EVENTBUS_EVENTS.RELOAD_TAB,
            intent.request?.request_params?.tab_id
          );
        } else {
          eventBus.$emit(intent.intentArea, intent);
        }
      }
      store.commit('event/setRemoveIntentsAll');
    }
  }
};

export const mixin = {
  computed: {
    urlParams() {
      // bad support of matchAll
      const regexp = /&|module=|action=|record=/gi;
      const str = location.href.slice(location.href.indexOf('?') + 1);

      const result = [...str.match(regexp)];
      const config = {};

      result.some((res, i) => {
        if (res === '&') return false;

        const index = str.indexOf(res);
        if (str[index - 1] && str[index - 1] !== '&') return false;

        const param = res.slice(0, res.length - 1);
        const nextRes = result[i + 1];
        const startIdx = res.length + index;
        const endIdx =
          nextRes && nextRes === '&'
            ? str.slice(index).indexOf(nextRes) + index
            : str.length;
        if (!config[param]) {
          config[param] = str.slice(startIdx, endIdx);
        }
      });

      return config;
    }
  },
  methods: {
    urlParamsToOldPage(url) {
      // bad support of matchAll
      const regexp =
        /&|module=|action=|record=|type_item=|page=|parentModule=|wizard=|option=|process_type=|import_module=|query=/gi;
      const str = url.slice(url.indexOf('?') + 1);
      const result = [...str.match(regexp)];
      const config = {};

      (result || []).some((res, i) => {
        if (res === '&') return false;

        const index = str.indexOf(res);
        if (str[index - 1] && str[index - 1] !== '&') return false;

        const param = res.slice(0, res.length - 1);
        const nextRes = result[i + 1];
        const startIdx = res.length + index;
        const endIdx =
          nextRes && nextRes === '&'
            ? str.slice(index).indexOf(nextRes) + index
            : str.length;
        if (!config[param]) {
          config[param] = str.slice(startIdx, endIdx);
        }
      });

      return config;
    },
    getIconName(url) {
      let urlParts = url.split('/');
      return urlParts[urlParts.length - 1].split('.')[0];
    },
    async sendFormRequestFromIntent(intent, additional_params) {
      let { request } = intent;
      const formData = new FormData();

      if (request?.url) {
        request.url
          .split('?')[1]
          .split('&')
          .forEach(element => {
            const parsedElement = element.split('=');
            formData.set(parsedElement[0], parsedElement[1]);
          });
      }

      // заполняем статические параметры, если они есть
      if (request?.request_params) {
        for (let param of Object.keys(request.request_params)) {
          if (Array.isArray(request.request_params[param])) {
            request.request_params[param].forEach(element => {
              formData.append(`${param}[]`, element);
            });
          } else {
            formData.set(param, request.request_params[param]);
          }
        }
      }
      // заполняем динамические параметры, если они есть
      if (request?.dynamic_request_params) {
        for (let param of Object.keys(request?.dynamic_request_params)) {
          if (Array.isArray(request.dynamic_request_params[param])) {
            request.dynamic_request_params[param].forEach(element => {
              formData.append(`${param}[]`, element);
            });
          } else {
            formData.set(param, request.dynamic_request_params[param]);
          }
        }
      }
      if (additional_params) {
        // заполняем дополнительные параметры, если они есть
        for (let param of Object.keys(additional_params)) {
          if (formData.has(param)) {
            formData.delete(param);
          }
          if (Array.isArray(additional_params[param])) {
            additional_params[param].forEach(element => {
              formData.append(`${param}[]`, element);
            });
          } else {
            formData.set(param, additional_params[param]);
          }
        }
      }

      const params = {
        header: {
          'Content-Type': 'multipart/form-data'
        }
      };

      return await postController({ options: formData, params });
    },
    createLinkFromIntent(request) {
      let link = '';
      let formUrlTextFromArray = params => {
        for (let opt in params) {
          if (Array.isArray(params[opt])) {
            let array = params[opt];
            for (let i = 0; i < array.length; i++) {
              link += '&' + opt + '[]=' + array[i];
            }
          } else {
            link += '&' + opt + '=' + params[opt];
          }
        }
      };

      if (request) {
        link = request.url;
        if (
          request.dynamic_request_params &&
          !Array.isArray(request.dynamic_request_params)
        ) {
          formUrlTextFromArray(request.dynamic_request_params);
        }

        if (request.request_params && !Array.isArray(request.request_params)) {
          formUrlTextFromArray(request.request_params);
        }
      }
      return link;
    },
    rawDate(date = '', format) {
      // raw dateformat by new date
      if (!date) return new Date();
      if (date && typeof date !== 'string') return date;

      const splitedFormat = format.toUpperCase().split(' ')[0].split(/[./-]/g);
      const splitedDate = date.split(' ')[0].split(/[./-]/g);
      const splitedTime = date.split(' ')[1];
      const dayIndex = splitedFormat.findIndex(f => f == 'DD');
      const monthIndex = splitedFormat.findIndex(f => f == 'MM');
      const yearIndex = splitedFormat.findIndex(f => f == 'YYYY');
      const hours = splitedTime ? splitedTime.split(':')[0] : 0;
      const minutes = splitedTime ? splitedTime.split(':')[1] : 0;

      if (splitedDate[0].length == 4) {
        // yyyy-mm-dd
        return new Date(
          splitedDate[0],
          splitedDate[1] - 1,
          splitedDate[2],
          hours,
          minutes
        );
      }

      let day = splitedDate[dayIndex];
      let month = splitedDate[monthIndex];
      const year = splitedDate[yearIndex];

      if (+month > 12) {
        day = splitedDate[monthIndex];
        month = splitedDate[dayIndex];
      }

      return new Date(year, month - 1, day, hours, minutes);
    },
    formatDate(date = '', format) {
      // formatted date
      return dayjs(this.rawDate(date, format)).format(format.toUpperCase());
    },
    getNewDate(date) {
      if (!date) return new Date();

      const [day, month, year] = date.split(' ')[0].split(/[./-]/g);
      const [hour, minute] = date.includes(':')
        ? date.split(' ')[1].split(':')
        : '00:00';

      return new Date(year, month - 1, day, hour, minute);
    },
    getTableData(data, columns) {
      let result = [];

      data.forEach(item => {
        let row = {};
        Object.keys(columns).forEach(col => {
          let column = (row[col.toLowerCase()] = {});
          Object.keys(columns[col]).forEach(colParam => {
            column[colParam] = columns[col][colParam];
          });
          column['value'] = item[col];
        });
        result.push(row);
      });

      return result;
    },
    formatHtml(text) {
      if (typeof text === 'string' && text) {
        const replacement = [
          [/&quot;/g, '"'],
          [/&gt;/g, '>'],
          [/&lt;/g, '<'],
          [/&#039;/g, "'"],
          [/&#38;/g, '"'],
          [/&#96;/g, '`'],
          [/%3A/g, ':']
        ];
        return text
          .replace(...replacement[0])
          .replace(...replacement[1])
          .replace(...replacement[2])
          .replace(...replacement[3])
          .replace(...replacement[4])
          .replace(...replacement[5])
          .replace(...replacement[6]);
      }
      return text;
    },
    confirmCloseDialog(params = {}, display, param) {
      store.commit('common/setVisibleDialog', {
        name: 'confirm_close_dialog',
        val: display,
        params
      });
      if (param && this[param]) this[param] = null;
    },
    closeDialog(dialogs, formName = 'form', ...params) {
      const hideDialog = dialog => {
        if (this.hasOwnProperty('is_visible')) {
          const dialogParams = this.is_visible
            ? [this['is_visible'], dialog]
            : [this[dialog], 'visible'];
          this.$set(...dialogParams, false);
        } else {
          dialogMixin.methods.setVisibleDialog(dialog, false);
        }
      };

      if (formName && this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }

      if (dialogs && Array.isArray(dialogs)) {
        dialogs.forEach(d => hideDialog(d));
      } else {
        hideDialog(dialogs);
      }

      const paramsForChange = params
        ? Array.isArray(params)
          ? params
          : [params]
        : [];

      paramsForChange.forEach(i => {
        if (this.hasOwnProperty(i)) {
          this[i] = null;
        } else {
          const module =
            this.module == MODULE.CANDIDATES_MODULE
              ? 'candidate'
              : this.module == MODULE.VACANCY_MODULE
              ? 'vacancy'
              : '';

          if (i) {
            store.commit(`${module}/setParam`, { name: i, val: null });
          }
        }
      });
    },
    validateNumberRange(required = false, value, callback, range) {
      if (Array.isArray(range)) {
        const [min, max] = range;

        if (
          (!min && typeof min == 'string') ||
          (!max && typeof max == 'string')
        )
          callback();

        if (min || max) {
          if (Number(min) > Number(max)) {
            callback(new Error('Введен неверный числовой диапазон'));
          } else callback();
        } else {
          callback();
        }
      } else {
        const [a, b] = Object.keys(range);
        const [signA, signB] = Object.values(range);
        const condition1 = signA === '<=' && signB === '>='; // error при > <
        const condition2 = signA === '<' && signB === '>'; // error при >= <=
        const min = this.form[a];
        const max = this.form[b];

        if (min && Number(max) !== 0) {
          if (condition1) {
            if (Number(min) > Number(max)) {
              callback(new Error('Введен неверный числовой диапазон'));
            }
          }
          if (condition2) {
            if (Number(min) >= Number(max)) {
              callback(new Error('Введен неверный числовой диапазон'));
            }
          }
        }
      }

      if (required && !value) {
        callback(new Error('Необходимо заполнить поле'));
      } else {
        callback();
      }
    },
    invalidDateRange(range, dateFormat) {
      let [start, end] = range;

      if (end && start) {
        start = this.rawDate(start, dateFormat);
        end = this.rawDate(end, dateFormat);

        return start > end;
      }

      return false;
    },
    invalidTimeRange(range, timeFormat) {
      let [start, end] = range;

      if (end && start) {
        start = dayjs(start, timeFormat).toDate();
        end = dayjs(end, timeFormat).toDate();

        return start > end;
      }

      return false;
    },
    validateDateRange(required = false, value, callback, range, dateFormat) {
      if (this.invalidDateRange(range, dateFormat)) {
        callback(new Error('Введен неверный диапазон дат'));
      }

      if (required && !value) {
        callback(new Error('Необходимо заполнить поле'));
      } else {
        callback();
      }
    },
    validateTimeRange(
      required = false,
      value,
      callback,
      range,
      timeFormat,
      letEmpty = false
    ) {
      if (letEmpty && range.every(r => !r)) callback();
      if (this.invalidTimeRange(range, timeFormat)) {
        callback(new Error('Введен неверный диапазон времени'));
      }

      if (required && !value) {
        callback(new Error('Необходимо заполнить поле'));
      } else {
        callback();
      }
    },
    handleChangeRange(start, end, formName) {
      if (!this.$refs[formName]) return;

      if (start && this[formName].hasOwnProperty(start)) {
        this.$refs[formName].validateField(start);
      }
      if (end && this[formName].hasOwnProperty(end)) {
        this.$refs[formName].validateField(end);
      }
    },
    catchError(err, msg, action = '') {
      console.log(action + ' error.', err);

      errorMsg.methods.showNotification({
        showClose: true,
        message: msg,
        type: 'error'
      });
    },
    recalcSelectHeight(name) {
      // пересчет высоты мультиселекта (фикс от подергивания элемента)
      setTimeout(() => {
        const input = document.querySelector(`.front input[name="${name}"]`);
        const select = input.closest('.el-select');
        const tagWrapper = select.querySelector('.el-select__tags');
        const tagSpan = select.querySelector('.el-select__tags>span');

        if (tagSpan) {
          const withScrollbar =
            tagSpan.offsetWidth > tagWrapper.offsetWidth ? 7 : 0;
          input.style.maxHeight =
            select.querySelector('.el-select__tags').offsetHeight -
            withScrollbar +
            'px';
        }
      }, 100);
    },
    resizeDialog() {
      const dialog =
        this.$parent.$refs.dialog ||
        (this.$refs.form && this.$refs.form.$el.closest('.el-dialog')) ||
        this.$refs.dialog?.$el.querySelector('.el-dialog');

      if (!dialog) return;

      const title = dialog.querySelector('.el-dialog__header');
      const buttons = dialog.querySelector('.buttons-panel');

      if (!title || !buttons) return;

      this.$nextTick(() => {
        // const dialogIndents = document.body.offsetHeight - dialog.offsetHeight;

        dialog
          .closest('.el-dialog__wrapper')
          .classList.remove('dialog--scrollable');
        dialog.querySelector('.el-dialog__body').style.maxHeight = '';

        if (dialog.offsetHeight >= document.body.offsetHeight) {
          const contentBodyHeight = title.offsetHeight + buttons.offsetHeight;
          /* + (dialogIndents > -1 ? dialogIndents : 0); */

          dialog
            .closest('.el-dialog__wrapper')
            .classList.add('dialog--scrollable');
          dialog.querySelector(
            '.el-dialog__body'
          ).style.maxHeight = `calc(100% - ${contentBodyHeight}px`;
        }

        if (
          buttons.offsetWidth !== dialog.offsetWidth &&
          dialog.querySelector('.buttons-panel')
        ) {
          dialog.querySelector('.buttons-panel').style.maxWidth =
            dialog.offsetWidth + 'px';
        }
      });
    }
  },
  components: { Message }
};

export const rules = {
  methods: {
    setRequiredFields(required, key) {
      if (required) {
        const validation = {
          required: true,
          message: 'Необходимо заполнить поле',
          trigger: ['change', 'input', 'blur']
        };
        const rule = this.rules[key]
          ? [...this.rules[key], validation]
          : [validation];

        this.$set(this.rules, key, rule);
      }
    },
    setRule(formName, name, rule = null) {
      if (rule && typeof rule === 'object') {
        const arrayRule = Array.isArray(rule) ? rule : [rule];
        this.$set(this.rules, name, arrayRule);
      } else {
        this.$delete(this.rules, name);
      }
      this.$nextTick(function () {
        this.$refs[formName].clearValidate();
      });
    },
    validateForm(form, fieldName) {
      let valid = [];
      const validateField = name => {
        // вынести в миксины setHidden, validateForm, handleChange + поменять во всех окнах
        if (this.fields[name].hidden) return true; // скрытые поля не проверяем

        this.rules[name].some(rule => {
          // вернуть первую ошибку поля
          let isCorrect = false;

          if (rule.required && !form[name]) {
            this.$set(this.fields[name], 'error', true);
          } else if (rule.validator) {
            const { invalid, fields } = rule.validator();
            isCorrect = !invalid;
            fields.forEach(field => {
              this.$set(this.fields[field], 'error', invalid);
              this.$set(
                this.fields[field],
                'message',
                invalid ? rule.message : ''
              );
            });
          } else {
            this.$set(this.fields[name], 'error', false);
            isCorrect = true;
          }

          valid.push(isCorrect);
          return !isCorrect;
        });
      };

      if (fieldName && this.rules[fieldName]) {
        validateField(fieldName);
      } else {
        for (let key in this.rules) {
          if (this.rules[key]) {
            validateField(key);
          }
        }
      }

      return valid.every(correct => correct);
    },
    setHidden(name, val) {
      this.$set(this.fields[name], 'hidden', val);
    },
    checkPhoneInput(form, name) {
      // временный хардкод для поля Телефон
      const phone = form[name];
      if (
        phone.slice(0, 3) !== '880' &&
        phone.slice(0, 1) === '8' &&
        phone.length > 2
      ) {
        // проверка на код Бангладеша и коды городов РФ, чтобы заменить +8 на +7
        const val = '7' + phone.slice(1);
        this.$set(form, name, val);
      }
    }
  }
};

export const metadata = {
  methods: {
    setButtonsData(metadata) {
      if (!metadata) return;

      metadata.forEach(btn => {
        if (Array.isArray(btn)) {
          this.setButtonsData(btn);
        } else {
          const {
            type,
            id,
            url,
            child,
            visibility,
            custom_display,
            error_text,
            popup_type
          } = btn;
          let callback;

          if (error_text) {
            store.commit('common/setNotification', { [btn.id]: error_text });
          }

          switch (type) {
            case BUTTON.TYPE.LINK:
              if (id == BUTTON.ID.CANCEL) {
                callback = () => {
                  const confirm = window.confirm(
                    'Закрыть без сохранения изменений?'
                  );
                  if (confirm) {
                    location.href = url;
                  }
                };
              } else if (id == BUTTON.ID.OPEN_QUESTIONNAIRE) {
                callback = () =>
                  this.fields.questionnaire.value
                    ? window.open(this.fields.questionnaire.value, '_blank')
                    : null;
              } else {
                callback = () => (location.href = url);
              }

              break;

            case BUTTON.TYPE.POPUP:
              if (!popup_type)
                dialogMixin.methods.setVisibleDialog(`${id}_dialog`, false);

              callback = () => {
                if (error_text) {
                  errorMsg.methods.showErrorMessage(error_text);
                  return;
                }

                if (popup_type) {
                  store.commit('application/setPopupType', popup_type);

                  dialogMixin.methods.setVisibleDialog(
                    `application_dialog`,
                    true
                  );
                } else
                  dialogMixin.methods.setVisibleDialog(`${id}_dialog`, true);

                if (
                  id === BUTTON.ID.OPEN_POSITIONS ||
                  id === BUTTON.ID.CANCEL_POSITIONS
                ) {
                  this.setAmountIncrement(`${id}_dialog`);
                }
              };
              break;

            case BUTTON.TYPE.DROPDOWN:
              this.$set(btn, 'submenu', this.data.length ? this.data : null);
              break;

            case BUTTON.TYPE.AJAX:
              switch (id) {
                case BUTTON.ID.PICK_CANDIDATE:
                  callback = () => this.showCandidatesList();
                  break;
                case BUTTON.ID.OK:
                case BUTTON.ID.SAVE:
                case BUTTON.ID.SAVE_AND_DOWNLOAD:
                case BUTTON.ID.SEND_EMAIL:
                case BUTTON.ID.PUBLISH:
                case BUTTON.ID.SAVE_PUBLICATOR:
                case BUTTON.ID.SAVE_AS_TEMPLATE:
                case BUTTON.ID.SAVE_AS_TEMPLATE_NOT_PUBLISH:
                  callback = () => {
                    if (
                      this.defaultParams &&
                      this.defaultParams.module ===
                        MODULE.HRPAC_PUBLISHED_VACANCY &&
                      this.defaultParams.action === 'savePublishedVacancy'
                    ) {
                      if (
                        store.state.publicator.hhData &&
                        !store.state.publicator.hhData.is_employer
                      ) {
                        return store.dispatch('common/catchError', {
                          msg: 'Текущий пользователь не является работодателем'
                        });
                      }
                      if (
                        store.state.publicator.hhData &&
                        store.state.publicator.hhData.employer.id
                      ) {
                        this.saveForm(
                          'form',
                          id == BUTTON.ID.SAVE_AND_DOWNLOAD ||
                            id == BUTTON.ID.PUBLISH
                        );
                      } else {
                        errorMsg.methods.showErrorMessage({
                          offset: 100,
                          showClose: true,
                          duration: 25000,
                          message:
                            'Для продолжения требуется авторизация на работном сайте',
                          type: 'error'
                        });
                      }
                    } else {
                      this.saveForm(
                        'form',
                        id == BUTTON.ID.SAVE_AND_DOWNLOAD ||
                          id == BUTTON.ID.PUBLISH
                      );
                    }
                  };

                  break;
                case BUTTON.ID.APPLY_FOR:
                  callback = () => this.goToAttachmentPage();
                  break;
                case BUTTON.ID.SEND_PD:
                  callback = () => this.sendPD();
                  break;
                // case BUTTON.ID.SEND_QUESTIONNAIRE:
                //   callback = () => this.sendQuestionnaire();
                //   break;
                case BUTTON.ID.SAVE_RESUME:
                  callback = () => this.saveResume();
                  break;
                case BUTTON.ID.ADD_TAG:
                  callback = () => this.createTag();
                  break;
                case BUTTON.ID.CANCEL:
                  callback = () => this.$emit('reset-callback', 'form');
                  break;
                case BUTTON.ID.PREVIEW:
                  callback = () => this.preview();
                  break;
                case BUTTON.ID.SAVE_MEETING:
                  callback = () => {
                    this.form?.email_switcher == '' ||
                    this.form?.email_switcher == '0'
                      ? this.saveForm(
                          'form',
                          id == BUTTON.ID.SAVE_AND_DOWNLOAD ||
                            id == BUTTON.ID.PUBLISH
                        )
                      : this.handleMeetingWithEmail();
                  };
                  break;

                default:
                  break;
              }

              break;

            case BUTTON.TYPE.PARENT:
            default:
              break;
          }

          if (custom_display) {
            store.commit('common/setParam', {
              name: 'customButtons',
              param: id,
              val: btn
            });
          }

          if (callback) {
            this.$set(btn, 'callback', callback);
          }
          // как идея с помощью личного параметра контролировать через стор состояние загрузки:
          // this.$set(btn, 'loading', false);

          if (visibility && visibility === BUTTON.PARAM.DISABLED && !child) {
            this.$set(btn, 'disabled', true);
          }

          // учитываем структуру с глубокой вложенностью кнопок
          if (child && child.length) {
            this.setButtonsData(btn.child);
          }
        }
      });
    },
    goToAttachmentPage() {
      this.$router.push(`candidates/AttachmentPage/${this.$router.params.id}`);
    },
    handleMeetingWithEmail() {
      //проверям все ли поля заполнены в обычной форме
      const meetingForm = this.$refs.form;
      let errorFields = this.getErrorValidFields(meetingForm);
      if (errorFields?.length) {
        scrollToError(errorFields);
      }
      const mainFormHasErrors = errorFields.length;
      //проверям все поля в форме отправки email-сообщения
      const emailForm = store.state.common.detachedEmailForm;
      errorFields = this.getErrorValidFields(emailForm);
      if (!mainFormHasErrors) {
        scrollToError(
          errorFields,
          document.getElementsByClassName('el-dialog__body')[0]
        );
      }
      const emailFormHasErrors = errorFields?.length;
      return !mainFormHasErrors && !emailFormHasErrors;
    },
    getErrorValidFields(form) {
      if (!form || !Object.keys(form).length) return;
      form.validate();
      return form.fields
        .filter(field => field.isRequired && field.validateState == 'error')
        .map(field => field?.labelFor);
    },
    setSubpanelData(subpanels) {
      if (!subpanels) return;

      const filteredSubpanels = subpanels.panelColumn.map(col =>
        col
          .filter(tab => tab.visibility !== 'hidden')
          .map((tab, i) => ({ ...tab, lazy: i !== 0 }))
      );
      const loadedTabs = {};

      store.commit('subpanels/setSubpanels', filteredSubpanels);

      filteredSubpanels.forEach((panelCol, i) => {
        if (panelCol.length) {
          const col = { id: panelCol[0].id, loading: false };
          store.commit('subpanels/setActiveSubpanel', { i, data: col });
          panelCol.forEach(tab => {
            store.commit('subpanels/setLoadedTabs', {
              tab: tab.id,
              loaded: !tab.lazy
            });
            loadedTabs[tab.id] = !tab.lazy;
          });
        }
      });

      return { filteredSubpanels, loadedTabs };
    },
    setFieldsData(fields = {}, module) {
      // новые метаданные для detailView
      const formattedFields = { ...fields };
      const blockedFields = {};

      this.metaData.panels.forEach(panel => {
        panel.rows.forEach(field => {
          const { value, name, type, lbl, visual_type } = field[0];

          if (!name && !lbl) return;

          const blocked = fields[name].blocked;
          let formattedVal =
            value && Array.isArray(value)
              ? value.map(v => mixin.methods.formatHtml(v))
              : mixin.methods.formatHtml(value);

          if (
            (type === FIELD.TYPE.DECIMAL || type === FIELD.TYPE.CURRENCY) &&
            visual_type != FIELD.TYPE.DECIMAL
          ) {
            formattedVal = formattedVal
              ? Number(formattedVal.split('.')[0])
              : formattedVal;
          }

          if (type == FIELD.TYPE.BOOL && blocked && Array.isArray(blocked)) {
            blockedFields[name] = [...blocked];
          }
          formattedFields[name] = {
            ...fields[name],
            value: formattedVal
          };
        });
      });

      // параметр для отслеживания родительского bool-поля
      Object.values(blockedFields).forEach(
        (name, i) =>
          (formattedFields[name].parent_field = Object.keys(blockedFields)[i])
      );

      store.commit(`${module}/setFields`, { ...formattedFields });
      store.commit(`${module}/setParam`, {
        name: 'metaData',
        val: this.metaData
      });
    },
    setDeepMenu(...params) {
      // формирование структуры многоуровневого меню для el-menu, поддерживаемой ui-библиотекой
      function isObject(val) {
        return typeof val === 'object';
      }
      const labels = {};
      const levels = {};
      const setOpt = (obj, targetObj = null, iterationNum = 0, level = 1) => {
        for (let key in obj) {
          const target = targetObj || {}; // || this.contactOpts;
          const prevLevel = level - 1;

          ++iterationNum;
          levels[level] = prevLevel
            ? `${levels[prevLevel]}-${iterationNum}`
            : `${level}-${iterationNum}`;

          if (isObject(obj[key])) {
            target[levels[level]] = {
              title: obj[key].name,
              submenu: {}
            };

            setOpt(obj[key].list, target[levels[level]].submenu, 0, level + 1);
          } else {
            labels[key] = obj[key];
            target[levels[level]] = {
              title: obj[key],
              type: key
            };
          }
        }
      };

      setOpt(...params);
      return labels;
    },
    setCommunications(cValue, option = null) {
      if (!option) return;
      const labels = this.setDeepMenu(option.value_type_list || {});

      // обработка данных средств связи
      cValue.forEach((contact /*, idx*/) => {
        const { id, value, value_type } = contact;
        if (value) {
          const { label, /*icon,*/ htmlType } = setContactData(
            value_type,
            null,
            labels[value_type] || ''
          );
          contact.label = label;
          // contact.icon = icon;
          contact.htmlType = htmlType;
          this.$set(this.form, id, mixin.methods.formatHtml(value));
        }
      });
    },
    setBlockedSchema() {
      if (!this.blocked) return;
      this.$set(this.blocked, 'schema', {});

      for (let name in this.fields) {
        const field = this.fields[name];
        if (
          field.blocked &&
          typeof field.blocked === 'object' &&
          !Array.isArray(field.blocked)
        ) {
          for (let key in field.blocked) {
            if (!this.blocked.schema[key]) {
              this.$set(this.blocked.schema, key, {});
            }
            this.$set(this.blocked.schema[key], field.name, field.blocked[key]);
          }
        }
      }
    },
    setVisibilityBlockedSchema() {
      if (!this.visibility_blocked) return;
      this.$set(this.visibility_blocked, 'schema', {});

      for (let name in this.fields) {
        const field = this.fields[name];
        if (
          field.visibility_blocked &&
          typeof field.visibility_blocked === 'object' &&
          !Array.isArray(field.visibility_blocked)
        ) {
          for (let key in field.visibility_blocked) {
            if (!this.visibility_blocked.schema[key]) {
              this.$set(this.visibility_blocked.schema, key, {});
            }
            this.$set(
              this.visibility_blocked.schema[key],
              field.name,
              field.visibility_blocked[key]
            );
          }
        }
      }
    },
    setHiddenFields(meta) {
      if (meta.hidden_fields) {
        meta.hidden_fields.forEach(field => {
          this.$set(this.form, field.name, this.formatHtml(field.value));

          if (field.id_name) {
            this.$set(
              this.form,
              form.methods.idFieldName(field.id_name),
              this.formatHtml(field.id_name?.value) || ''
            );
          }
        });
      }
    },
    processMetadata() {
      this.setBlockedSchema();
      this.setVisibilityBlockedSchema();

      if (this.metaData) {
        this.setButtonsData(this.metaData.buttons_menu);
        this.setHiddenFields(this.metaData);

        // this.setSubpanelData(this.metaData.subpanels);
        if (this.metaData.panels) {
          this.metaData.panels.forEach(item => {
            const { panelColumn } = item;
            // временно, потом убрать условие:
            if (panelColumn) {
              panelColumn.forEach(panel => {
                this.iterateRows(panel);
              });
            } else {
              this.iterateRows(item);
            }
          });
        }

        if (this.metaData.custom_panels) {
          this.metaData.custom_panels.forEach(item => {
            const { panelColumn } = item;
            // временно, потом убрать условие:
            if (panelColumn) {
              panelColumn.forEach(panel => {
                if (Array.isArray(panel) && panel.rows) {
                  this.iterateRows(panel);
                }
              });
            } else {
              this.iterateRows(item);
            }
          });
        }

        if (store.state.edit.initialSendRequests?.length) {
          store.state.edit.initialSendRequests.forEach(
            async ({ value, field }) => {
              await this.sendDynamicRequest(value, field, true);
            }
          );
          store.commit('edit/setEmptyInitialDynamicRequest');
        }

        const allFieldsData = {};
        for (let key in this.fields) {
          allFieldsData[key] = this.fields[key].value;
        }
        store.commit('edit/setEtalonForm', { ...allFieldsData, ...this.form });
      }
    },
    iterateRows(panel) {
      panel.rows?.forEach(row => {
        const fields = row.fields || row;
        fields.forEach(field => {
          if (!field.name) return;

          const {
            name,
            id_name,
            value,
            default: defaultVal,
            front_field_type,
            type,
            subtype,
            option,
            options,
            fields,
            fields_arr,
            isMultiSelect,
            multiple,
            blocked,
            visibility_blocked,
            visibility,
            buttons,
            visual_type,
            visual_value,
            quick_create,
            calc_sum,
            calc_multiplication,
            dynamic_request,
            initial_help_prefilling,
            self_clean,
            hidden_panel_label,
            blocked_values
          } = field;
          const isMultiple = multiple || isMultiSelect;
          const communication = type === FIELD.TYPE.COMMUNICATION;
          const conditionVal =
            (isMultiple && type !== FIELD.TYPE.VARCHAR) || communication
              ? []
              : '';
          const defaultValue =
            !this.fields?.id?.value && !this.bean?.id?.value
              ? defaultVal || conditionVal || this.fields[name]?.default
              : null;

          if (type === FIELD.TYPE.GROUP && fields) {
            fields.forEach(subfield => {
              const {
                name,
                option,
                options,
                value,
                type,
                subtype,
                blocked,
                visibility_blocked,
                buttons,
                id_name,
                default: defaultVal,
                multiple,
                visual_type,
                visual_value,
                calc_sum,
                calc_multiplication,
                dynamic_request,
                initial_help_prefilling,
                self_clean,
                hidden_panel_label
              } = subfield;
              const defaultValue =
                !this.fields?.id?.value && !this.bean?.id?.value
                  ? defaultVal || this.fields[name]?.default
                  : null;

              if (
                (type === FIELD.TYPE.DECIMAL || type === FIELD.TYPE.CURRENCY) &&
                visual_type !== FIELD.TYPE.DECIMAL
              ) {
                this.$set(
                  this.form,
                  name,
                  value ? Number(value.split('.')[0]) : value
                );
              } else if (
                (type == FIELD.TYPE.DATE || type == FIELD.TYPE.DATETIME) &&
                this.datepicker?.dateFormat &&
                value
              ) {
                this.$set(
                  this.form,
                  name,
                  this.formatDate(value, this.datepicker.dateFormat)
                );
              } else if (type === FIELD.TYPE.INT) {
                this.$set(
                  this.form,
                  name,
                  value !== '' ? +value.replace(/\s*/g, '') : value
                );
              } else if (visual_type == FIELD.VISUAL_TYPE.TIMEPICKER) {
                this.$set(
                  this.form,
                  name,
                  value.split(' ').length > 1
                    ? value.split(' ')[1]
                    : value.split(' ')[0]
                );
              } else {
                this.$set(
                  this.form,
                  name,
                  this.formatHtml(defaultValue || value)
                );
              }

              if (visibility === FIELD.PARAM.DISABLED) {
                this.$set(
                  subfield,
                  FIELD.PARAM.VISIBILITY,
                  FIELD.PARAM.DISABLED
                );
              }

              if (buttons) {
                this.setButtonsData(buttons);
              }

              this.setValidation(subfield, fields_arr);
              if (visual_type !== FIELD.VISUAL_TYPE.ENUM) {
                this.setOptions(option || options, name, type);
              }
              if (blocked) {
                this.setBlocked(
                  blocked,
                  value,
                  form.methods.idFieldName(id_name) || name,
                  multiple
                );
              }
              if (visibility_blocked) {
                this.setVisibilityBlocked(
                  visibility_blocked,
                  form.methods.idFieldName(id_name) || name
                );
              }

              if (fields_arr && this.blocked[name]) {
                this.$set(
                  this.form,
                  name,
                  Array.isArray(this.form[name]) ? [] : ''
                );
              }

              if (calc_multiplication) {
                this.multiplicate(this.form[name], subfield, true);

                if (this.fields[calc_multiplication.output]) {
                  this.$set(
                    this.fields[calc_multiplication.output],
                    'default',
                    this.form[calc_multiplication.output]
                  );
                }

                if (!this.fields[calc_multiplication.output]?.calc_sum) return;

                const bindedField =
                  this.fields[calc_multiplication.output].calc_sum.output;
                const bindedFieldValue =
                  this.form[
                    this.fields[calc_multiplication.output]?.calc_sum?.output
                  ];

                if (this.fields[bindedField]) {
                  this.$set(
                    this.fields[bindedField],
                    'default',
                    bindedFieldValue
                  );
                }
              }

              if (calc_sum) {
                this.summarize(this.form[name], subfield);

                if (this.fields[calc_sum.output]) {
                  this.$set(
                    this.fields[calc_sum.output],
                    'default',
                    this.form[calc_sum.output]
                  );
                }
              }

              if (
                visual_value &&
                (type == FIELD.TYPE.RELLINK || subtype == FIELD.TYPE.RELLINK)
              ) {
                this.setOptions(visual_value, name, type);
              } else if (
                visual_value &&
                type == FIELD.TYPE.RELATE &&
                !!visual_value.name &&
                !!visual_value.id &&
                visual_type !== FIELD.VISUAL_TYPE.ENUM
              ) {
                this.setOptions(
                  { [visual_value.id]: visual_value.name },
                  name,
                  type
                );
              }

              if (dynamic_request && value && initial_help_prefilling) {
                store.commit('edit/setInitialDynamicRequest', {
                  value,
                  field: subfield
                });
              }

              if (self_clean) {
                const schema = {};

                self_clean.forEach(item => {
                  for (let key in item) {
                    if (!schema[key]) schema[key] = [];
                    const fields = Object.assign({}, item);
                    delete fields[key];

                    const condition = {
                      value: item[key],
                      cleaned_field: name,
                      fields
                    };

                    schema[key].push(condition);
                  }
                });

                store.commit('edit/setCleanFieldSchema', schema);
              }

              if (hidden_panel_label) {
                for (let label of Object.keys(hidden_panel_label)) {
                  if (hidden_panel_label[label]?.priority_condition) {
                    let conditionNoEffect = false;
                    for (let field of Object.keys(
                      hidden_panel_label[label].priority_condition
                    )) {
                      if (
                        this.form[field] ==
                        hidden_panel_label[label].priority_condition[field]
                      ) {
                        conditionNoEffect = true;
                        break;
                      }
                    }
                    if (!conditionNoEffect) {
                      store.commit('edit/setHiddenPanelLabel', {
                        lbl: label,
                        val: value === hidden_panel_label[label].condition
                      });
                    }
                  } else {
                    store.commit('edit/setHiddenPanelLabel', {
                      lbl: label,
                      val: value === hidden_panel_label[label].condition
                    });
                  }
                }
              }
            });
          } else {
            const textType = this.textType(type);
            const fieldVal =
              visual_type == 'sub_checkbox' &&
              Array.isArray(value) &&
              this.form?.work_site !== 'superjob'
                ? value.join(',')
                : type === FIELD.TYPE.MULTIENUM &&
                  value &&
                  typeof value == 'number'
                ? String(value)
                : typeof value == 'string' &&
                  value &&
                  type === FIELD.TYPE.MULTIENUM
                ? value
                    .replace(/\^/g, '')
                    .split(',')
                    .map(v => this.formatHtml(v))
                : (type === FIELD.TYPE.DECIMAL ||
                    type === FIELD.TYPE.CURRENCY) &&
                  value &&
                  typeof value == 'string' &&
                  visual_type !== FIELD.TYPE.DECIMAL
                ? Number(value.split('.')[0])
                : visual_type == FIELD.VISUAL_TYPE.TIMEPICKER && value
                ? value.split(' ').length > 1
                  ? value.split(' ')[1]
                  : value.split(' ')[0]
                : type === FIELD.TYPE.INT && value !== ''
                ? +value.replace(/\s*/g, '')
                : textType
                ? this.formatHtml(value)
                : type === FIELD.TYPE.MULTIARRAY && value.length
                ? name == FIELD.ID.LANGUAGE_LEVEL
                  ? (Array.isArray(value) ? value : []).map(
                      ({ id_language, id_language_id, level, level_id }) => ({
                        id_language: String(id_language),
                        level: String(level),
                        id_language_id,
                        level_id
                      })
                    )
                  : (Array.isArray(value) ? value : []).map(item => {
                      const obj = {};
                      for (let key in item) {
                        obj[key] =
                          Array.isArray(item[key]) ||
                          typeof item[key] != 'string'
                            ? item[key]
                            : String(item[key]);
                      }
                      return obj;
                    })
                : (type == FIELD.TYPE.DATE || type == FIELD.TYPE.DATETIME) &&
                  this.datepicker?.dateFormat &&
                  value
                ? name == FIELD.ID.BIRTH_DATE && !value
                  ? ''
                  : this.formatDate(value, this.datepicker.dateFormat)
                : type == FIELD.TYPE.BOOL
                ? defaultValue
                  ? String(+defaultValue)
                  : String(+value)
                : this.formatHtml(defaultValue || value) || '';

            if (
              type == FIELD.TYPE.RELLINK &&
              Array.isArray(value) &&
              value[0] != ''
            ) {
              this.$set(this.form, name, fieldVal);
            } else if (
              type == FIELD.TYPE.RELLINK &&
              !Array.isArray(value) &&
              (multiple || isMultiSelect)
            ) {
              this.$set(this.form, name, [fieldVal]);
            } else if (
              type != FIELD.TYPE.RELLINK ||
              (subtype == FIELD.TYPE.RELLINK && !Array.isArray(value))
            ) {
              name == 'addition_amount'
                ? this.$set(this.form, name, fieldVal.toString())
                : this.$set(this.form, name, fieldVal);
            }

            this.setValidation(field, fields_arr);
            if (visual_type !== FIELD.VISUAL_TYPE.ENUM) {
              this.setOptions(option || options, name, type);
            }
            if (blocked) {
              this.setBlocked(
                blocked,
                value,
                form.methods.idFieldName(id_name) || name,
                multiple
              );
            }
            if (visibility_blocked) {
              this.setVisibilityBlocked(
                visibility_blocked,
                form.methods.idFieldName(id_name) || name
              );
            }

            if (fields_arr && this.blocked[name]) {
              this.$set(
                this.form,
                name,
                Array.isArray(this.form[name]) ? [] : ''
              );
            }

            if (calc_multiplication) {
              this.multiplicate(this.form[name], field, true);

              if (this.fields[calc_multiplication.output]) {
                this.$set(
                  this.fields[calc_multiplication.output],
                  'default',
                  this.form[calc_multiplication.output]
                );
              }

              if (!this.fields[calc_multiplication.output]?.calc_sum) return;

              const bindedField =
                this.fields[calc_multiplication.output].calc_sum.output;
              const bindedFieldValue =
                this.form[
                  this.fields[calc_multiplication.output]?.calc_sum?.output
                ];

              if (this.fields[bindedField]) {
                this.$set(
                  this.fields[bindedField],
                  'default',
                  bindedFieldValue
                );
              }
            }

            if (calc_sum) {
              this.summarize(this.form[name], field);

              if (this.fields[calc_sum.output]) {
                this.$set(
                  this.fields[calc_sum.output],
                  'default',
                  this.form[calc_sum.output]
                );
              }
            }

            if (
              visual_value &&
              (type == FIELD.TYPE.RELLINK || subtype == FIELD.TYPE.RELLINK)
            ) {
              this.setOptions(visual_value, name, type);
            } else if (
              visual_value &&
              type == FIELD.TYPE.RELATE &&
              !!visual_value.name &&
              !!visual_value.id &&
              visual_type !== FIELD.VISUAL_TYPE.ENUM
            ) {
              this.setOptions(
                { [visual_value.id]: visual_value.name },
                name,
                type
              );
            }

            if (quick_create) {
              getController({
                url: `/index.php?module=HRPAC_VACANCY&action=check_access&field_name=${name}&to_pdf=true`
              })
                .then(resp => {
                  if (resp.data && typeof resp.data.data != 'string') {
                    store.commit('common/setConfig', {
                      ...store.state.common.config,
                      createOptionAccess: {
                        [name]: !!resp.data.data
                      }
                    });
                  } else throw new Error(resp?.data?.data);
                })
                .catch(err => {
                  this.catchError(
                    err,
                    'Возникла ошибка при проверке доступа создания записи в справочнике',
                    'error access to create'
                  );

                  store.commit('common/setConfig', {
                    ...store.state.common.config,
                    createOptionAccess: { [name]: false }
                  });
                });
            }

            if (dynamic_request && fieldVal && initial_help_prefilling) {
              store.commit('edit/setInitialDynamicRequest', {
                value: fieldVal,
                field
              });
            }

            if (self_clean) {
              const schema = {};
              self_clean.forEach(item => {
                for (let key in item) {
                  if (!schema[key]) schema[key] = [];
                  const fields = Object.assign({}, item);
                  delete fields[key];

                  const condition = {
                    value: item[key],
                    cleaned_field: name,
                    fields
                  };

                  schema[key].push(condition);
                }
              });

              store.commit('edit/setCleanFieldSchema', schema);
            }

            if (hidden_panel_label) {
              for (let label of Object.keys(hidden_panel_label)) {
                if (hidden_panel_label[label]?.priority_condition) {
                  let conditionNoEffect = false;
                  for (let field of Object.keys(
                    hidden_panel_label[label].priority_condition
                  )) {
                    if (
                      this.form[field] ==
                      hidden_panel_label[label].priority_condition[field]
                    ) {
                      conditionNoEffect = true;
                      break;
                    }
                  }
                  if (!conditionNoEffect) {
                    store.commit('edit/setHiddenPanelLabel', {
                      lbl: label,
                      val: fieldVal === hidden_panel_label[label].condition
                    });
                  }
                } else {
                  store.commit('edit/setHiddenPanelLabel', {
                    lbl: label,
                    val: fieldVal === hidden_panel_label[label].condition
                  });
                }
              }
            }
          }

          if (blocked_values) {
            const keys = Object.keys(blocked_values);
            let blockedVals = {};
            keys.forEach(key => {
              blockedVals = {
                ...blockedVals,
                [key]: { [name]: blocked_values[key] }
              };
            });
            this.blockedValues = blockedVals;
          }

          if (this.skillFields && front_field_type) {
            this.skillFields.push(name);
          }

          if (id_name) {
            const { name, value, default: defaultVal } = id_name;
            this.$set(
              this.form,
              name || id_name,
              this.formatHtml(value || defaultVal || '')
            );
            this.setBlocked(blocked, value, id_name?.name, multiple); // id_name || name
            this.setVisibilityBlocked(
              visibility_blocked,
              form.methods.idFieldName(id_name) || name
            );
          }

          if (buttons) {
            this.setButtonsData(buttons);
          }

          if (communication && value && Array.isArray(value)) {
            this.setCommunications(value, option);
          }
        });
      });
    },
    formatSpecOptions(opts, field) {
      const formattedOptions = {};
      for (let category in opts) {
        formattedOptions[category] = {
          category: opts[category].category,
          specializations: {}
        };

        for (let spec in opts[category].specializations) {
          const splitedSpec = spec.split('.'); // для избежания бага с накоплением категорий+специализаций через точку
          formattedOptions[category].specializations[
            `${category}.${splitedSpec[splitedSpec.length - 1]}`
          ] = opts[category].specializations[spec];
        }
      }
      this.$set(field, 'options', formattedOptions);
    }
  }
};

// обновление без перезагрузки определенных компонентов
export const update = {
  methods: {
    updateSubpanels(tabs) {
      // учесть что обращение в стор может быть к разным модулям или к единому (subpanels)
      const tabs_arr = Array.isArray(tabs) ? tabs : [tabs];
      const loadedTabs = store.state.subpanels.loadedTabs;
      tabs_arr.forEach(tab => {
        if (loadedTabs[tab]) {
          // возможно потом вынести в общий store модуль:
          store.commit('subpanels/updateActiveSubpanel', tab);
        }
      });
    }
  }
};

export const form = {
  methods: {
    handleScroll(evt, el) {
      if (window.scrollY > SCROLL_VALUE) {
        el.classList.add('scroll');
      } else {
        el.classList.remove('scroll');
      }
    },
    selectType(type) {
      return (
        type === FIELD.TYPE.RELATE ||
        type === FIELD.TYPE.RELLINK ||
        type === FIELD.TYPE.ENUM ||
        type === FIELD.TYPE.MULTIENUM ||
        type === FIELD.TYPE.CURRENCY_ID ||
        type === FIELD.TYPE.DYNAMICENUM
      );
    },
    dateType(type) {
      return (
        type === FIELD.TYPE.DATE ||
        type === FIELD.TYPE.DATETIME ||
        type === FIELD.TYPE.DATETIMECOMBO
      );
    },
    textType(type) {
      return (
        type === FIELD.TYPE.TEXT ||
        type === FIELD.TYPE.WYSIWYG ||
        type === FIELD.TYPE.EMAILBODY
      );
    },
    hidden(field) {
      return (
        field.hasOwnProperty(FIELD.PARAM.VISIBILITY) &&
        field.visibility === FIELD.PARAM.HIDDEN
      );
    },
    disabled(field) {
      return (
        field.hasOwnProperty(FIELD.PARAM.VISIBILITY) &&
        field.visibility === FIELD.PARAM.DISABLED
      );
    },
    idFieldName(id_name) {
      return id_name && id_name?.name ? id_name.name : id_name;
    },
    switcherField(field) {
      return field.type === FIELD.TYPE.BOOL && field.visual_type == 'switcher';
    },
    dynamicEnumField(field) {
      return field.type === FIELD.TYPE.DYNAMICENUM;
    },
    isEmptyField(field, value) {
      const hasNoValue = Array.isArray(value)
        ? !value.length
        : field.type == 'currency' || field.type == 'decimal'
        ? !Number(value)
        : !value || !String(value).trim();

      return field.required && hasNoValue;
    },
    fieldColumnClass(row, item, index) {
      if (
        (row.length == 1 && location.href.indexOf('/edit') == -1) ||
        item.type === FIELD.TYPE.IMAGE ||
        item.type == 'MeansCommunication' ||
        item.type == 'DetailExperience' ||
        item.type == 'Education' ||
        item.type == 'LanguageProficiency' ||
        item.type == 'SkillsTraining' ||
        item.name == 'vacancies'
      ) {
        return `${this.prefixClass}-form__section-row`;
      } else if (item.type) {
        return [
          `${this.prefixClass}-form__section-column`,
          index == 0
            ? `${this.prefixClass}-form__section-column--left`
            : `${this.prefixClass}-form__section-column--right`
        ];
      }
    },
    multiplicate(val, field, setDefaultVal = false) {
      const { term, output, coefficient } = field.calc_multiplication;

      if (
        (output && !this.fields[output]) ||
        (term && Array.isArray(term)
          ? !term.every(name => !!this.fields[name])
          : !this.fields[term])
      )
        return;

      const multValues = (data, obj) =>
        Array.isArray(data)
          ? data.reduce(
              (acc, name) =>
                (obj[name] && obj[name].hasOwnProperty('value')
                  ? +obj[name].value || 0
                  : +obj[name] || 0) * acc,
              1
            )
          : obj[data];
      const bindedVal = !setDefaultVal
        ? multValues(term, this.form)
        : multValues(term, this.fields);
      const formatted = value =>
        String(value).indexOf('%') > -1
          ? +value.slice(0, -1).replace(',', '.') / 100
          : +value;

      if (isNaN(formatted(val)) || isNaN(formatted(bindedVal))) return;

      const decimalType = this.fields[output].visual_type == 'decimal';
      const value = String(
        formatted(val) *
          formatted(bindedVal) *
          (coefficient !== undefined ? coefficient : 1)
      );
      const roundedValue = value
        ? decimalType
          ? Number(value).toFixed(2)
          : value
        : '';

      this.$set(this.form, output, roundedValue);

      if (this.fields[output]?.calc_sum) {
        this.summarize(value, this.fields[output], setDefaultVal);
      }
    },
    summarize(val, field, setDefaultVal = false) {
      const { term, output } = field.calc_sum;

      if (
        (output && !this.fields[output]) ||
        (term && Array.isArray(term)
          ? !term.every(name => !!this.fields[name])
          : !this.fields[term])
      )
        return;

      const hasValues = (data, obj) =>
        (Array.isArray(data)
          ? data.some(name =>
              obj[name] && obj[name].hasOwnProperty('value')
                ? !!obj[name].value
                : !!obj[name]
            )
          : !!obj[data]) || !!val;
      const sumValues = (data, obj) =>
        Array.isArray(data)
          ? data.reduce(
              (acc, name) =>
                (obj[name] && obj[name].hasOwnProperty('value')
                  ? +obj[name].value || 0
                  : +obj[name] || 0) + acc,
              0
            )
          : obj[data];
      const bindedVal = !setDefaultVal
        ? sumValues(term, this.form)
        : sumValues(term, this.fields);
      const notEmptyFields = !setDefaultVal
        ? hasValues(term, this.form)
        : hasValues(term, this.fields);

      if (isNaN(+val) || isNaN(+bindedVal)) return;

      const decimalType = this.fields[output].visual_type == 'decimal';
      const sum = +val + +bindedVal;
      const roundedValue = !decimalType
        ? sum
        : notEmptyFields
        ? Number(sum).toFixed(2)
        : !sum && '';

      this.$set(this.form, output, roundedValue);
    },
    processDynamicRequestAnswer(resp, ignoreFieldPrefill = false) {
      if (resp.data && typeof resp.data !== 'string') {
        for (let key in resp.data) {
          if (Array.isArray(resp.data[key])) return;
          const {
            prefill_value: val,
            visual_value,
            help_value
          } = resp.data[key];

          if (
            !val &&
            !resp.data[key].hasOwnProperty('help_value') &&
            (!visual_value ||
              (!Array.isArray(visual_value) && visual_value.hasOwnProperty('')))
          )
            continue;
          // предполагаем что у скрытых полей уже пустое значение
          if (
            !document.querySelector(`form [data-name="${key}"]`) &&
            !document.querySelector(`form [name="${key}"]`) &&
            !this.fields[key].hidden_prefill_accept
          )
            continue;

          let helpAccess = true;
          if (this.fields[key]?.help_display) {
            const obj = this.fields[key]?.help_display;
            helpAccess = Object.keys(obj).every(key => {
              return (
                (Array.isArray(obj[key]) &&
                  obj[key].includes(this.form[key])) ||
                (obj[key] == '%not_empty%' && !!this.form[key])
              );
            });
          }

          if (this.fields[key]?.show_sap_help && helpAccess) {
            store.commit('edit/setSapHelp', {
              key,
              val: help_value ? this.formatHtml(help_value) : ''
            });
            if (ignoreFieldPrefill) store.commit('edit/updateKey'); // индивидуальные ключи
          }

          if (ignoreFieldPrefill /* && newValue === this.form[key] */) continue;
          if (!resp.data[key].hasOwnProperty('prefill_value')) {
            continue;
          }

          const newValue =
            val && typeof val == 'string'
              ? (this.fields[key]?.type === FIELD.TYPE.DECIMAL ||
                  this.fields[key]?.type === FIELD.TYPE.CURRENCY) &&
                Number(val.split('.')[0]) == 0
                ? val
                : this.formatHtml(val)
              : val;

          this.$set(this.form, key, newValue);

          if (this.fields[key]?.id_name) {
            const optId =
              visual_value && !Array.isArray(visual_value)
                ? Object.keys(visual_value)[0]
                : '';
            const optName = this.formatHtml(val);
            this.$set(
              this.form,
              this.idFieldName(this.fields[key].id_name),
              optId || ''
            );

            this.setOptions({ [optId]: optName }, key, this.fields[key].type);
          } else if (visual_value && Array.isArray(val)) {
            const options = [];
            for (let id in visual_value) {
              options.push({
                id,
                name: this.formatHtml(visual_value[id])
              });
            }
            this.$set(this.options, key, options);
          }

          if (this.fields[key].hidden_panel_label) {
            let hidden_panel_label = this.fields[key].hidden_panel_label;
            for (let label of Object.keys(hidden_panel_label)) {
              if (hidden_panel_label[label]?.priority_condition) {
                let conditionNoEffect = false;
                for (let field of Object.keys(
                  hidden_panel_label[label].priority_condition
                )) {
                  if (
                    this.form[field] ==
                    hidden_panel_label[label].priority_condition[field]
                  ) {
                    conditionNoEffect = true;
                    break;
                  }
                }
                if (!conditionNoEffect) {
                  store.commit('edit/setHiddenPanelLabel', {
                    lbl: label,
                    val: newValue === hidden_panel_label[label].condition
                  });
                }
              } else {
                store.commit('edit/setHiddenPanelLabel', {
                  lbl: label,
                  val: newValue === hidden_panel_label[label].condition
                });
              }
            }
          }

          if (this.fields[key]?.blocked) {
            this.setBlocked(
              this.fields[key]?.blocked,
              newValue,
              this.idFieldName(this.fields[key]?.id_name) || key,
              this.fields[key]?.multiple
            );
          }
          if (this.fields[key]?.visibility_blocked) {
            this.setVisibilityBlocked(
              this.fields[key]?.visibility_blocked,
              this.idFieldName(this.fields[key]?.id_name) || key
            );
          }

          this.callback.field.change(this.fields[key], newValue);
        }
      }
    },
    sendDynamicRequest(val, field, initialSend = false) {
      this.$nextTick(() => {
        if (field.dynamic_request) {
          const { method, action, fields } = field.dynamic_request;
          const params = {};

          params[field.name] = val;

          if (
            !document.querySelector(`form [data-name="${field.name}"]`) &&
            !document.querySelector(`form [name="${field.name}"]`)
          )
            return;

          if (field.id_name) {
            params[this.idFieldName(field.id_name)] =
              this.form[this.idFieldName(field.id_name)] || '';
          }

          fields.forEach(name => {
            params[name] = this.form[name] || '';

            if (this.fields[name]?.id_name) {
              params[this.idFieldName(this.fields[name].id_name)] =
                this.form[this.idFieldName(this.fields[name].id_name)] || '';
            }
          });

          if (
            !initialSend &&
            Object.values(params).every((val, i) => {
              return (
                val === store.state.edit.etalonForm[Object.keys(params)[i]]
              );
            })
          )
            return;

          store.commit('edit/setEtalonForm', params);

          if (method == 'GET') {
            getController({
              url: action,
              params
            })
              .then(resp => this.processDynamicRequestAnswer(resp, initialSend))
              .catch(err => this.catchError(err, err, 'dynamic request'));
          } else if (method == 'POST') {
            const formData = new FormData();

            for (let key in params) {
              if (Array.isArray(params[key])) {
                params[key].forEach(p => formData.append(key + '[]', p));
              } else formData.set(key, params[key]);
            }
            postController({
              url: action,
              options: formData
            })
              .then(resp => this.processDynamicRequestAnswer(resp, initialSend))
              .catch(err => this.catchError(err, err, 'dynamic request'));
          }
        }
      });
    },
    setOptions(opt, name, type) {
      if (
        type == FIELD.TYPE.RADIOBUTTON ||
        type == FIELD.TYPE.LANGUAGE_LEVEL ||
        type == FIELD.TYPE.ANOTHER_WORK_PLACE
      )
        return;

      if (opt) {
        let options = Array.isArray(opt) ? opt : [];

        if (!opt.hasOwnProperty('length')) {
          if (
            opt.hasOwnProperty('id') &&
            !opt.id &&
            opt.hasOwnProperty('name') &&
            !opt.name
          )
            return;

          for (let key in opt) {
            if (opt[key] && !opt[key].hasOwnProperty('length')) {
              const val =
                type && type === FIELD.TYPE.CURRENCY_ID
                  ? opt[key].symbol
                  : FIELD.VISUAL_TYPE.SUB_RADIO ||
                    FIELD.VISUAL_TYPE.SUB_CHECKBOX
                  ? opt[key].category
                  : opt[key].name;
              options.push({ id: this.formatHtml(key), name: val });
            } else {
              options.push({
                id: this.formatHtml(key),
                name: this.formatHtml(opt[key])
              });
            }
          }
        } else if (Array.isArray(opt)) {
          if (opt.filter(i => i.constructor.name == 'Object').length > 0) {
            options = opt.map(i => ({ ...i, name: this.formatHtml(i.name) }));
          } else {
            options = opt;
          }
        }

        this.$set(
          this.options,
          name,
          type != FIELD.TYPE.ENUM ? this.sortNameByAZ(options) : options
        );
      }
    },
    sortNameByAZ(list) {
      if (!list || !Array.isArray(list)) return;

      if (list.some(i => i.hasOwnProperty('name') && !i.name)) return list;
      else return list.sort((a, b) => a.name.localeCompare(b.name));
    },
    setBlocked(blocked, value, name, multiple = false) {
      if (blocked && Array.isArray(blocked)) {
        blocked.forEach(key => {
          if (this.fields[name]?.type == FIELD.TYPE.BOOL) {
            this.$set(this.blocked, key, !Number(value));
            this.$set(this.form, key, Array.isArray(value) ? [] : '');

            if (
              !Number(value) &&
              store.state.edit.sapHelps[key] &&
              this.fields[key].show_sap_help
            ) {
              // прячем подсказку при скрытии поля по задаче HRCRMSM-810
              store.commit('edit/setSapHelp', { key, val: '' });
            }
          }
        });
      } else if (blocked && Object.keys(this.blocked.schema).length) {
        // параметры функции не используются
        for (let key in this.blocked.schema) {
          const blockConditions = this.blocked.schema[key];
          const res = [];
          const compareValues = (obj = {}, bindedField) => {
            const unblockValues = obj[bindedField];
            const bindedFieldVal =
              (this.fields[bindedField].id_name
                ? this.form[this.idFieldName(this.fields[bindedField].id_name)]
                : this.form[bindedField]) || '';

            const noIncludedVal = Array.isArray(bindedFieldVal)
              ? !unblockValues.some(v => bindedFieldVal.some(vv => vv === v))
              : !unblockValues.includes(bindedFieldVal);
            res.push(noIncludedVal);
          };

          for (let bindedField in blockConditions) {
            compareValues(blockConditions, bindedField);

            if (this.blocked.schema[bindedField]) {
              for (let siblingBindedField in this.blocked.schema[bindedField]) {
                compareValues(
                  this.blocked.schema[bindedField],
                  siblingBindedField
                );
              }
            }
          }

          const isBlocked = res.some(v => !!v);
          this.$set(this.blocked, key, isBlocked);

          if (isBlocked) {
            this.$set(
              this.form,
              key,
              multiple || this.fields[key].multiple ? [] : ''
            );
            if (this.fields[key].id_name)
              this.$set(
                this.form,
                this.idFieldName(this.fields[key].id_name),
                ''
              );

            if (
              store.state.edit.sapHelps[key] &&
              this.fields[key].show_sap_help
            ) {
              // прячем подсказку при скрытии поля по задаче HRCRMSM-810
              store.commit('edit/setSapHelp', { key, val: '' });
            }
          }
        }
      } else if (blocked && isPlainObject(blocked)) {
        for (let key in blocked) {
          const values = blocked[key];
          const idFieldVal = this.form[name];
          this.$set(this.blocked, key, !values.includes(idFieldVal));

          if (name === 'employment_form') {
            this.$set(this.blocked, key, !values.includes(value));
          } else {
            this.$set(this.blocked, key, !values.includes(idFieldVal));
          }

          if (!values.includes(idFieldVal)) {
            this.$set(this.form, key, multiple ? [] : '');
          }
        }
      }
    },
    setVisibilityBlocked(blocked) {
      if (
        blocked &&
        this.visibility_blocked?.schema &&
        Object.keys(this.visibility_blocked.schema).length
      ) {
        // параметры функции не используются
        for (let key in this.visibility_blocked.schema) {
          const blockConditions = this.visibility_blocked.schema[key];
          const res = [];
          const compareValues = (obj = {}, bindedField) => {
            const unblockValues = obj[bindedField];
            const bindedFieldVal =
              (this.fields[bindedField].id_name
                ? this.form[this.idFieldName(this.fields[bindedField].id_name)]
                : this.form[bindedField]) || '';

            const includedVal = Array.isArray(bindedFieldVal)
              ? unblockValues.some(v => bindedFieldVal.some(vv => vv === v))
              : unblockValues.includes(bindedFieldVal);
            res.push(includedVal);
          };

          for (let bindedField in blockConditions) {
            compareValues(blockConditions, bindedField);

            if (this.visibility_blocked.schema[bindedField]) {
              for (let siblingBindedField in this.visibility_blocked.schema[
                bindedField
              ]) {
                compareValues(
                  this.visibility_blocked.schema[bindedField],
                  siblingBindedField
                );
              }
            }
          }

          const isBlocked = res.some(v => !!v);
          this.$set(this.visibility_blocked, key, isBlocked);
        }
      }
    },
    setValidation(field, range) {
      const { required, name, validation, type } = field;
      this.setRequiredFields(required, name);

      if (validation && validation.rules && range) {
        const { target, rules } = validation;

        if (!this.fields[target]) return;

        const sourceIdx = range.findIndex(i => i === name);
        const targetIdx = range.findIndex(i => i === target);
        const min =
          Math.min(sourceIdx, targetIdx) === sourceIdx
            ? { [name]: rules }
            : { [target]: this.fields[target].validation.rules };
        const max =
          Math.max(sourceIdx, targetIdx) === sourceIdx
            ? { [name]: rules }
            : { [target]: this.fields[target].validation.rules };

        const rangeRules = {
          validator: (rule, value, callback) => {
            this.validateNumberRange(required, value, callback, {
              ...min,
              ...max
            });
          },
          trigger: 'blur'
        };
        const rule = this.rules[name]
          ? [...this.rules[name], rangeRules]
          : [rangeRules];
        this.$set(this.rules, name, rule);
        this.$set(this.fields[name], 'trigger', target);
      }

      if (type === FIELD.TYPE.URL) {
        const urlRules = {
          validator: (rule, value, callback) => {
            const regexp = /^(https?:\/\/)/i;
            if (value && !regexp.test(value)) {
              callback(new Error('Введен некорректный URL адрес'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        };
        this.$set(this.rules, name, urlRules);
      }
    },
    setFieldValue(name, val, blocked, trigger = false) {
      if (this.form[name] === val) return;
      this.$set(this.form, name, val);

      if (this.fields && this.fields[name]?.trigger) {
        // для полей-диапазонов
        this.handleChangeRange(name, this.fields[name].trigger, 'form');
      } else if (this.$refs['form'] && name && this.form.hasOwnProperty(name)) {
        if (
          this.$refs['form'].$el.querySelector(`[name="${name}"]`) ||
          this.$refs['form'].$el.querySelector(`[data-name="${name}"]`)
        ) {
          this.$refs['form'].validateField(name);
        }
      }

      if (this.fields[name]?.hidden_panel_label) {
        let hidden_panel_label = this.fields[name].hidden_panel_label;
        for (let label of Object.keys(hidden_panel_label)) {
          if (hidden_panel_label[label]?.priority_condition) {
            let conditionNoEffect = false;
            for (let field of Object.keys(
              hidden_panel_label[label].priority_condition
            )) {
              if (
                this.form[field] ==
                hidden_panel_label[label].priority_condition[field]
              ) {
                conditionNoEffect = true;
                break;
              }
            }
            if (!conditionNoEffect) {
              store.commit('edit/setHiddenPanelLabel', {
                lbl: label,
                val: val === hidden_panel_label[label].condition
              });
            }
          } else {
            store.commit('edit/setHiddenPanelLabel', {
              lbl: label,
              val: val === hidden_panel_label[label].condition
            });
          }
        }
      }

      const checkBlocked = (name, val, blocked) => {
        if (this.fields[name] && this.fields[name]?.type == FIELD.TYPE.VARCHAR)
          return;
        if (blocked && Array.isArray(blocked)) {
          if (this.fields[name]?.type !== FIELD.TYPE.BOOL) {
            blocked.forEach(key => {
              const updateBlockedFields = name => {
                if (val.length == 1) {
                  this.$delete(this.blocked, name);
                } else {
                  this.$set(this.blocked, name, true);
                  this.$set(this.form, name, this.fields[name].default || '');

                  if (
                    store.state.edit.sapHelps[name] &&
                    this.fields[name].show_sap_help
                  ) {
                    // прячем подсказку при скрытии поля по задаче HRCRMSM-810
                    store.commit('edit/setSapHelp', { key: name, val: '' });
                  }
                }

                if (this.fields[name].blocked) {
                  checkBlocked(
                    name,
                    this.form[name],
                    this.fields[name].blocked
                  );
                }
              };

              if (typeof key !== 'object') {
                updateBlockedFields(key);
              }
            });
          } else {
            // для связи с булевыми полями
            blocked.forEach(key => {
              if (
                !Number(val) &&
                (!this.fields[key].visibility == 'disabled' ||
                  !this.fields[key].visibility)
              ) {
                this.$set(this.form, key, '');
                if (this.fields[key].id_name && this.fields[key].id_name.name) {
                  this.$set(this.form, this.fields[key].id_name.name, '');
                }
              }

              this.$set(this.blocked, key, !Number(val));

              if (
                !Number(val) &&
                store.state.edit.sapHelps[key] &&
                this.fields[key].show_sap_help
              ) {
                // прячем подсказку при скрытии поля по задаче HRCRMSM-810
                store.commit('edit/setSapHelp', { key, val: '' });
              }
            });
          }
        } else if (
          blocked &&
          isPlainObject(blocked) &&
          this.fields[name].type != FIELD.TYPE.RELATE
        ) {
          /* const isBlocked = */ this.setBlocked(blocked, val, name);

          // if (isBlocked) {
          //   this.$refs['form'].validate();
          // }
        }

        if (
          this.fields[name].type != FIELD.TYPE.RELATE &&
          this.visibility_blocked?.schema &&
          Object.keys(this.visibility_blocked.schema).length
        ) {
          this.setVisibilityBlocked(true);
        }
      };

      if (this.fields[name]) {
        checkBlocked(name, val, blocked);
      }

      if (
        name == 'date_start' ||
        name == 'date_end' ||
        name == FIELD.ID.CALL_TIME_FROM ||
        name == FIELD.ID.CALL_TIME_TO
      ) {
        if (name == 'date_start' || name == 'date_end') {
          this.handleChangeRange('date_start', 'date_end', 'form');
          this.$emit('update-time', name, val);
        } else if (
          name == FIELD.ID.CALL_TIME_FROM ||
          name == FIELD.ID.CALL_TIME_TO
        ) {
          this.handleChangeRange(
            FIELD.ID.CALL_TIME_FROM,
            FIELD.ID.CALL_TIME_TO,
            'form'
          );
        }

        if (name != 'date_start' && name != 'date_end') return;
        if (
          this.fields[name]?.validation?.rules == '<' ||
          this.fields[name]?.validation?.rules == '<='
        ) {
          let hours = val.split(':')[0];
          const minutes = val.split(':')[1];
          const nextHour = String(+hours + 1);
          hours = hours != 23 ? (nextHour < 10 ? '0' : '') + nextHour : '00';
          this.$set(
            this.form,
            this.fields[name]?.validation.target,
            hours + ':' + minutes
          );
          this.$emit(
            'update-time',
            this.fields[name]?.validation.target,
            hours + ':' + minutes
          );
        }
      }

      if (name == 'date_event') {
        this.$emit('update-time', name, val);
      }

      if (
        name == 'areas' &&
        this.fields[name].type == FIELD.TYPE.ENUM &&
        this.form?.work_site == 'trudvsem'
      ) {
        store.commit('publicator/setTrudvsemCity', val);
      }

      if (
        this.defParams?.module === MODULE.HRPAC_COORDINATION_REQUESTS ||
        this.module === MODULE.HRPAC_COORDINATION_REQUESTS
      ) {
        this.addToCash(this.form);
      }

      if (trigger) this.getCleanFieldSchema(name, val);

      //в случае если выбрано значение поля, от которого зависит
      //доступность значений других полей, вторые необходимо очистить,
      //если перестали соблюдаться условия их доступности
      if (this.fields[name]?.blocked_values) {
        //вызываем с задержкой,чтобы успели заполниться id_name полей
        setTimeout(() => {
          const fields = Object.keys(this.fields[name]?.blocked_values);
          fields.forEach(field => {
            Object.keys(this.fields[name]?.blocked_values[field]).forEach(
              conditionalVal => {
                if (
                  conditionalVal === this.form[this.fields[name].id_name.name]
                ) {
                  this.$set(
                    this.form,
                    field,
                    this.form[field].filter(
                      val =>
                        !this.fields[name]?.blocked_values[field][
                          conditionalVal
                        ].includes(val)
                    )
                  );
                }
              }
            );
          });
        });
      }
    },
    getCleanFieldSchema(name, val) {
      if (store.state.edit.cleanFieldSchema[name]) {
        store.state.edit.cleanFieldSchema[name].forEach(
          ({ value, fields, cleaned_field }) => {
            if (value !== '%any%' && Array.isArray(value) && value[0] !== val)
              return;
            if (
              (Array.isArray(this.form[cleaned_field]) &&
                !this.form[cleaned_field].length) ||
              this.form[cleaned_field] === ''
            )
              return;

            if (!Object.keys(fields).length) {
              this.resetFieldValue(cleaned_field);
            } else {
              const valid = Object.values(fields).every(
                (v, i) =>
                  v === '%any%' ||
                  (Array.isArray(v) &&
                    v[0] === this.form[Object.keys(fields)][i])
              );

              if (valid) {
                this.resetFieldValue(cleaned_field);
              }
            }
          }
        );
      }
    },
    resetFieldValue(name) {
      const val = Array.isArray(this.form[name]) ? [] : '';
      this.$set(this.form, name, val);
      if (this.fields[name]?.id_name) {
        this.$set(this.form, this.idFieldName(this.fields[name].id_name), '');

        if (store.state.edit.cleanFieldSchema[name]) {
          this.getCleanFieldSchema(
            this.idFieldName(this.fields[name].id_name),
            ''
          );
        }
      }

      if (store.state.edit.cleanFieldSchema[name]) {
        this.getCleanFieldSchema(name, val);
      }
    },
    async addToCash(form) {
      try {
        this.requestSent = true;
        const formData = new FormData();
        formData.set('module', MODULE.HRPAC_COORDINATION_REQUESTS);
        formData.set('action', 'save_in_cache');
        formData.set('form', JSON.stringify(form));

        await postController({ options: formData });
      } catch (err) {
        console.error(err);
      }
    },
    changeOption(name, idField = {}, option, formName = 'form') {
      if (name && option && idField.name) {
        if (idField?.name) this[formName][idField.name] = option?.id || '';

        if (this.fields?.[name]?.blocked) {
          this.setBlocked(this.fields[name].blocked, option.id, name);
        }
      }

      if (this.fields?.[name]?.visibility_blocked) {
        this.setVisibilityBlocked(
          this.fields[name].visibility_blocked,
          this.idFieldName(idField)
        );
      }

      if (name == FIELD.ID.POLYGRAPH_OFFICER_NAME && option.id) {
        store.commit('common/setPolygraph', option.id);
      }

      if (
        name === FIELD.ID.EMAILS_EMAIL_TEMPLATES_NAME ||
        name === FIELD.ID.HRPAC_VACANCY_TEMPLATE_NAME
      ) {
        this.selectTemplate(this[formName][idField.name]);
      }

      if (+this[formName].email_switcher && name === FIELD.ID.VACANCY_NAME) {
        this[formName].email_switcher = false;
      }

      if (+this[formName].email_switcher && name === FIELD.ID.CANDIDATE_NAME) {
        this[formName].email_switcher = false;
      }

      if (name === FIELD.ID.CANDIDATE_NAME) {
        const params = store.state.subpanels.emailPanelData;
        params['candidate_id'] = this[formName].hrpac_candidate_id;
        store.commit('subpanels/setEmailData', params);
      }

      // if (
      //   name === FIELD.ID.SUBDIVISION_NAME ||
      //   name === FIELD.ID.REASON_FOR_OPENING
      // ) {
      //   const subdivisionId =
      //     name === FIELD.ID.SUBDIVISION_NAME
      //       ? this[formName][idField.name]
      //       : this[formName][FIELD.ID.SUBDIVISION_ID];
      //   const reasonForOpeningId =
      //     name === FIELD.ID.REASON_FOR_OPENING
      //       ? this[formName][idField.name]
      //       : this[formName][FIELD.ID.REASON_FOR_OPENING_ID];
      //   this.selectDivision(name, subdivisionId, reasonForOpeningId);
      // }

      // if (name === FIELD.ID.MANNING_TABLE_NAME) {
      //   this.updateVacancyName(this[formName][idField.name]);
      // }
    },
    clearFields(exceptFields = []) {
      for (let field in this.form) {
        if (exceptFields.indexOf(field) == -1) {
          if (Array.isArray(this.form[field])) {
            this.$set(this.form, field, []);
          } else if (typeof this.form[field] == 'number') {
            this.$set(this.form, field, field == 'amount' ? 1 : 0);
          } else if (typeof this.form[field] == 'object') {
            this.$set(this.form, field, {});
          } else if (typeof this.form[field] == 'string') {
            this.$set(this.form, field, '');
          }
        }
      }
      if (this.addToCash) this.addToCash(this.form);
    },
    formatSalary(val, key, precision = 2) {
      this.setFieldValue(key, Number(val).toFixed(precision));
    }
  }
};

export const saveForm = {
  methods: {
    formDefaultParams(module, id) {
      return {
        module: module,
        record: id || '',
        action: ACTION.SAVE,
        jsqon_return: 1
      };
    },
    async saveForm(formName = 'form', specialParam = false) {
      store.commit('common/setSaveFlag', true);
      let validateStatus = false;

      const defaultParams = this.defaultParams
        ? this.defaultParams
        : this.formDefaultParams(
            this.$route?.meta?.module == MODULE.VACANCY_TEMPLATE_MODULE
              ? MODULE.VACANCY_TEMPLATE_MODULE
              : this.module,
            this.fields?.id?.value || ''
          );

      const sendForm = async () => {
        if (this.requestSent) return;

        this.requestSent = true;

        const formData = new FormData();
        const form = { ...defaultParams, ...this.form };
        const params = {};

        for (let key in form) {
          if (
            this.fields.hasOwnProperty(key) ||
            defaultParams[key] ||
            key === FIELD.ID.RECOGNITION_RESUME_ID
          ) {
            if (Array.isArray(form[key])) {
              if (key === FIELD.ID.COMMUNICATIONS) {
                if (this.form.communications.length) {
                  this.form.communications.forEach((item, idx) => {
                    const contact = {
                      value_type: item.value_type,
                      value: item.value,
                      sort: idx,
                      id: item.id || ''
                    };
                    for (let key in contact) {
                      const prop = `${FIELD.ID.COMMUNICATIONS}[${idx}][${key}]`;
                      formData.set(prop, contact[key]);
                    }
                  });
                } else {
                  formData.set(FIELD.ID.COMMUNICATIONS, []);
                }
              } else if (key === FIELD.ID.DETAIL_EXPERIENCE) {
                if (this.form.detail_experience.length) {
                  this.form.detail_experience.forEach(item => {
                    item.fields.forEach(field => {
                      const detail = {
                        [field.name]: field.value
                      };
                      for (let key in detail) {
                        const prop = `${'detail_experience'}[${
                          item.id
                        }][${key}]`;
                        formData.set(prop, detail[key]);
                      }
                    });
                  });
                } else {
                  formData.set('detail_experience', []);
                }
              } else if (
                key === FIELD.ID.EDUCATION &&
                this.fields[key].type != FIELD.TYPE.ENUM
              ) {
                if (this.form.education.length) {
                  this.form.education.map(item => {
                    item.fields.forEach(field => {
                      const education = {
                        [field.name]: field.value
                      };
                      for (let key in education) {
                        const prop = `${'education'}[${item.id}][${key}]`;
                        formData.set(prop, education[key]);
                      }
                    });
                  });
                } else {
                  formData.set('education', []);
                }
              } else if (key === FIELD.ID.LANGUAGE) {
                if (this.form.language_proficiency.length) {
                  this.form.language_proficiency.map(item => {
                    item.fields.forEach(field => {
                      const language = {
                        [field.name]: field.value
                      };
                      for (let key in language) {
                        const prop = `${'language_proficiency'}[${
                          item.id
                        }][${key}]`;
                        formData.set(prop, language[key]);
                      }
                    });
                  });
                } else {
                  formData.set('language_proficiency', []);
                }
              } else if (key === 'recomendation') {
                if (this.form.recomendation.length) {
                  this.form.recomendation.map(item => {
                    item.fields.forEach(field => {
                      const recomendation = {
                        [field.name]: field.value
                      };
                      for (let key in recomendation) {
                        const prop = `${'recomendation'}[${item.id}][${key}]`;
                        formData.set(prop, recomendation[key]);
                      }
                    });
                  });
                } else {
                  formData.set('recomendation', []);
                }
              } else if (key == FIELD.ID.QUALIFICATION) {
                if (this.form.skills_training.length) {
                  this.form.skills_training.map(item => {
                    item.fields.forEach(field => {
                      const qualification = {
                        [field.name]: field.value
                      };
                      for (let key in qualification) {
                        const prop = `${'skills_training'}[${item.id}][${key}]`;
                        formData.set(prop, qualification[key]);
                      }
                    });
                  });
                } else {
                  formData.set('skills_training', []);
                }
              } else if (
                this.fields[key] &&
                this.fields[key].type == FIELD.TYPE.MULTIENUM
              ) {
                formData.set(key, form[key] ? form[key].join(',') : '');
              } else {
                if (
                  !form[key].length &&
                  this.defaultParams?.module !== MODULE.HRPAC_EVENT
                ) {
                  params[`${key}[]`] = '';
                } else {
                  params[key] = form[key];
                }
              }
            } else if (key === FIELD.ID.PHOTO && this.photo_file.length) {
              const { raw: blob, name } = this.photo_file[0];
              formData.set('photo_file', blob, name);
            } else if (
              this.fields[key] &&
              this.fields[key].type == FIELD.TYPE.DATETIME &&
              this.fields[key].visual_type == FIELD.VISUAL_TYPE.TIMEPICKER
            ) {
              const dateField =
                this.form[this.fields[key]?.validation?.parent] || '';
              if (dateField) formData.set(key, `${dateField} ${form[key]}`);
            } else if (this.fields[key]?.visual_type == FIELD.TYPE.DECIMAL) {
              formData.set(key, form[key] ? Number(form[key]).toFixed(2) : '');
            } else {
              const keyName =
                this.fields[key] && this.fields[key].ajax_param_name
                  ? this.fields[key].ajax_param_name
                  : key;
              const options =
                this.fields[key] &&
                (this.fields[key].option ||
                  this.fields[key].options ||
                  this.options[key] ||
                  []);
              const keyValue =
                this.fields[key] &&
                this.fields[key].visual_type == FIELD.VISUAL_TYPE.ENUM
                  ? options
                      .filter(({ id }) => id === form[key])
                      .map(({ name }) => name)[0]
                  : form[key];
              formData.set(keyName, keyValue || '');
            }
          } else if (key == 'addition_amount') {
            this.isClosePositionPopup
              ? formData.set(key, Number(`-${form[key]}`) || '')
              : formData.set(key, Number(form[key]) || '');
          } else {
            formData.set(key, form[key] || '');
          }

          if (this.fields[key]?.blocked) {
            if (
              Array.isArray(this.fields[key].blocked) &&
              this.fields[key].blocked.some(
                fld => this.fields[fld] && this.fields[fld].type == 'bool'
              )
            ) {
              this.fields[key].blocked.forEach(fld => {
                if (this.fields[fld].type == 'bool') {
                  formData.set(fld, form[key] ? '1' : '0');
                }
              });
            } else if (
              !Array.isArray(this.fields[key].blocked) &&
              this.fields[key].type == 'bool'
            ) {
              formData.set(this.fields[key].blocked, form[key] ? '1' : '0');
            }
          }
        }

        // обработка прикрепленных файлов в формах
        if (
          this.files &&
          Array.isArray(this.files) &&
          this.defaultParams.module == MODULE.EMAILS
        ) {
          if (formData.has('email_attachment')) {
            formData.delete('email_attachment');
          }
          this.files.forEach(file => {
            const { raw: blob, name } = file;
            if (file.type == 'template' || file.type == 'forward') {
              formData.append('template_attachment[]', file.id);
            } else if (file.type == 'removed') {
              formData.append('temp_remove_attachment[]', file.id);
            } else {
              formData.append('email_attachment[]', blob, name);
            }
          });
        }

        this.loading = true;
        if (defaultParams.module == MODULE.HRPAC_PUBLISHED_VACANCY) {
          return true;
        }

        try {
          const response = await postController({
            url: this.requestUrl ? this.requestUrl : undefined,
            options: formData,
            params: {
              header: {
                'Content-Type': 'multipart/form-data'
              },
              params
            }
          });

          store.commit('event/setIntents', response?.data?.intents);

          const error = response?.data?.errors || response?.data?.error;
          if (error) {
            if (Array.isArray(error)) {
              error.forEach(err => errorMsg.methods.showErrorMessage(err));
            } else {
              errorMsg.methods.showErrorMessage(
                error?.error_text?.error || error?.error_text || error
              );

              if (this.isEmailForm) {
                this.$emit('savedFormData');
              }
              return;
            }
          }

          if (
            this.module == MODULE.CANDIDATES_MODULE &&
            response?.data?.id &&
            !(this.prefixClass && this.prefixClass == 'dialog')
          ) {
            if (
              response?.data?.intents?.[0]?.action === 'DetailViewDublicate'
            ) {
              store.commit('dublicates/setParam', {
                name: 'saveCompare',
                val: response.data.id
              });
              this.$router.push({
                name: 'candidateCompare',
                params: { id: response.data.id }
              });
            } else {
              store.commit('edit/setMetadata', {});
              this.$router.push(`/candidates/${response.data.id}`);
            }
          } else if (
            this.module == MODULE.VACANCY_MODULE &&
            response?.data?.id &&
            this.module == defaultParams.module &&
            !(this.prefixClass && this.prefixClass == 'dialog')
          ) {
            this.$router.push(`/vacancies/${response.data.id}`);
            store.commit('edit/setMetadata', {});
          } else if (
            defaultParams.module == MODULE.VACANCY_TEMPLATE_MODULE &&
            this.vacancyId
          ) {
            if (response?.data?.intents) {
              store.commit('event/setIntents', response?.data?.intents);
              this.parse();
            } else {
              this.$router.push(`/vacancies/${this.vacancyId}`);
              store.commit('edit/setMetadata', {});
            }
          } else if (
            this.module == MODULE.USERS &&
            response?.data?.id &&
            this.module == defaultParams.module &&
            !(this.prefixClass && this.prefixClass == 'dialog')
          ) {
            this.$router.push(`/users/${response.data.id}/edit`);
            store.commit('edit/setMetadata', {});
          } else if (defaultParams.module == MODULE.VACANCY_TEMPLATE_MODULE) {
            store.commit('event/setIntents', response?.data?.intents);
            this.parse();
          }

          if (this.formView === 'popup') {
            if (response.data.reboot) location.reload();

            if (
              this.type &&
              (this.type === 'offer' || this.type === 'employee-exit')
            ) {
              if (specialParam) {
                const docId = response.data.document_id;
                this.downloadFile(
                  `index.php?entryPoint=download&id=${docId}&type=Documents`
                );
              }
            }

            this.requestSent = false;

            store.commit('event/setAsyncIntentDone', true);
            this.parse();
            store.commit('edit/setMetadata', {});
            this.$emit('savedFormData');
          }
        } catch (err) {
          if (defaultParams.module == MODULE.HRPAC_PUBLISHED_VACANCY) {
            errorMsg.methods.showNotification({
              offset: 80,
              showClose: true,
              message: 'Проверьте заполнение обязательных полей',
              duration: 15000,
              type: 'error'
            });
          } else {
            if (err.response?.data?.error?.error_text) {
              const errorMessage =
                err.response?.data?.error?.error_text?.error ||
                err.response?.data?.error?.error_text;
              errorMsg.methods.showErrorMessage(
                errorMessage ||
                  'Возникла ошибка отправки данных формы. Попробуйте еще раз.'
              );
            } else
              mixin.methods.catchError(
                err,
                'Возникла ошибка отправки данных формы. Попробуйте еще раз.',
                'save form'
              );
          }
        } finally {
          this.requestSent = false;
          this.loading = false;

          // store.commit('edit/setMetadata', {});
        }
      };

      // проверка валидации в обособленных формах
      const detachedForms = store.state.common.detachedForm;

      if (this.resetAddress) {
        this.$delete(this.rules, FIELD.ID.WORK_PLACE);
      }

      if (
        detachedForms &&
        Object.keys(detachedForms.fields).some(name => this.fields[name])
      ) {
        store.commit('common/setDetachedFormMode', true);

        const valid = Object.values(detachedForms.validateStatus).every(
          valid => valid
        );

        if (!valid) return;

        for (let name in detachedForms.fields) {
          const hasField =
            this.fields[name] &&
            (this.fields[name].schema ||
              this.fields[name].option?.value_type_list);

          if (!hasField) continue;

          this.form[name] = [];
          this.form[name] = detachedForms.fields[name];
          this.$set(this.form, name, detachedForms.fields[name]);
        }
      }

      store.commit('common/setRequestState', false);

      return await new Promise((resolve, reject) => {
        this.$refs[formName].validate(async (valid, fields) => {
          validateStatus = true;

          // для полей, которых по какой-то причине обходит валидатор:
          if (
            !Object.keys(fields).length &&
            this.$refs[formName].$el.querySelectorAll(
              '.is-empty-field.is-required'
            ).length
          ) {
            valid = false;
            this.$refs[formName].$el
              .querySelectorAll('.is-empty-field.is-required')
              .forEach(el => {
                el.classList.add('is-error');
                if (el.dataset?.name && !fields[el.dataset?.name]) {
                  fields[el.dataset.name] = el;
                }

                const wrapperEl =
                  this.$refs[formName].$el.closest(
                    '.dialog--scrollable .el-dialog__body'
                  ) ||
                  this.$refs[formName].$el.closest(
                    '.dialog .el-dialog__body'
                  ) ||
                  document.querySelector('.app-wrapper .wrapper .el-form') ||
                  window;
                const field = this.$refs[formName].$el.querySelector(
                  '.is-empty-field.is-required [name]'
                )
                  ? this.$refs[formName].$el.querySelector(
                      '.is-empty-field.is-required [name]'
                    ).name ||
                    this.$refs[formName].$el.querySelector(
                      '.is-empty-field.is-required [name]'
                    ).dataset?.name
                  : null;
                if (field) {
                  scrollToError(
                    [this.fields[field]],
                    wrapperEl,
                    defaultParams.module == MODULE.HRPAC_PUBLISHED_VACANCY
                      ? `#pane-${specialParam}`
                      : null
                  );
                }
                return;
              });
          }

          if (valid) {
            await sendForm();
            await resolve(valid);
          } else {
            store.commit('common/setClickSaveform', false);
            const errorFields = Object.keys(fields).map(
              field => this.fields[field]
            );
            if (
              this.collapsedPanels &&
              Object.keys(this.collapsedPanels).length
            ) {
              Object.keys(this.collapsedPanels).forEach(key => {
                this.collapsedPanels[key] = false;
              });
            }

            const wrapperEl =
              this.$refs[formName].$el.closest(
                '.dialog--scrollable .el-dialog__body'
              ) ||
              this.$refs[formName].$el.closest('.dialog .el-dialog__body') ||
              this.$refs[formName].$el.closest('.candidate') ||
              this.$refs[formName].$el.closest('.vacancy-form') ||
              document.querySelector('.app-wrapper .wrapper .el-form') ||
              window;
            scrollToError(
              errorFields,
              wrapperEl,
              defaultParams.module == MODULE.HRPAC_PUBLISHED_VACANCY
                ? `#pane-${specialParam}`
                : null
            );

            this.dialogLoading = false;

            reject(valid);
          }
        });

        if (!validateStatus) {
          // доп. кейс, если функция валидации не срабатывает
          let success = this.$refs[formName].fields
            .filter(field => field.isRequired)
            .every(
              field => field.fieldValue && field.validateState !== 'error'
            );

          if (success) {
            sendForm();
            resolve(success);
          } else {
            const errorFields = this.$refs[formName].fields
              .filter(field => field.isRequired)
              .every(
                field => field.fieldValue || field.validateState == 'error'
              )
              .map(({ field }) => this.fields[field]);

            scrollToError(errorFields);
            reject(success);
          }
        }

        store.commit('common/setDetachedFormMode', false);
      });
    }
  }
};

export const stage = {
  methods: {
    stagesLength(stages) {
      if (stages.hasOwnProperty('length')) {
        return stages.length;
      } else {
        return Object.keys(stages).length;
      }
    },
    isLimited(stage, currentStage, stages) {
      if (!stage || !currentStage) return;
      const stagesCount = this.stagesLength(stages);
      const requiredStages = Object.values(stages).filter(
        item =>
          item.required_stage == 'required' &&
          item.required_position === 'required_bottom' &&
          item.sort != stagesCount
      );

      if (
        currentStage.required_position !== 'required_bottom' ||
        (currentStage.sort == stagesCount && currentStage.required_stage)
      ) {
        const [, ...notFirstStage] = requiredStages;
        const hasStage = notFirstStage.filter(i => i.id === stage.id).length;
        return !!hasStage;
      } else {
        const acceptStage = requiredStages[requiredStages.length - 1];
        if (
          currentStage.sort === acceptStage.sort &&
          currentStage.required_stage
        ) {
          return true;
        } else {
          const sortIndex = String(Number(currentStage.sort) + 2);
          const hasStage = requiredStages.filter(i => i.id === stage.id).length;

          return Number(stage.sort) >= Number(sortIndex) && !!hasStage;
        }
      }
    },
    isAcceptStage(stage, stages) {
      if (!stage) return;
      return (
        stage.required_position === 'required_bottom' &&
        stage.sort == this.stagesLength(stages) - 1
      );
    },
    isRejectStage(stage, stages) {
      if (!stage) return;
      return (
        stage.required_position === 'required_bottom' &&
        stage.sort == this.stagesLength(stages)
      );
    }
  }
};

export const errorMsg = {
  methods: {
    // больше не используется
    showMessage(data = {}) {
      Message(data);
    },
    // для тостов с 1 кнопкой передаем тип 'notificationType' = 'toast-link'
    // для обычных тостов не передаем тип 'notificationType'
    showNotification(data = {}) {
      let newData = data;
      newData['position'] = 'bottom-left';
      newData['offset'] = 0;
      newData['customClass'] =
        newData['showClose'] && newData['showClose'] == true
          ? ' notification-show-close'
          : ' notification-without-close';
      if (newData['notificationType'] == 'toast-link') {
        newData['customClass'] = newData['customClass'] + ' toast-link';
        newData['dangerouslyUseHTMLString'] = true;
        newData[
          'message'
        ] = `<p class="notification-title">${newData.title}</p><a href="${newData.link}" target="_blank" class="link-button">${newData.buttonText}</a>`;
        newData['title'] = '';
      }
      if (data.type) {
        newData['customClass'] += ` el-notification--${data.type}`;
      }

      Notification(newData);
    },
    // для вывода нескольких строчек в одном тосте
    showMultiTextNotification(data = {}) {
      let newData = data;
      newData['position'] = 'bottom-left';
      newData['offset'] = 0;
      newData['customClass'] =
        newData['showClose'] && newData['showClose'] == true
          ? ' notification-show-close'
          : ' notification-without-close';
      if (newData['messageArray'].length) {
        newData['dangerouslyUseHTMLString'] = true;
        newData['messageArray'].forEach(message => {
          newData[
            'message'
          ] += `<p class="notification-text--multi">${message}</p>`;
        });
      }
      if (data.type) {
        newData['customClass'] += ` el-notification--${data.type}`;
      }

      Notification(newData);
    },
    // для тостов с доп текстом и 1 или 2 кнопками передаем тип 'notificationType' = 'notification-link'
    // кнопки имеют структуру button = [{link: '....', text: '.....'}]
    showNotificationWithLinks(data = {}) {
      let newData = data;
      newData['position'] = 'bottom-left';
      newData['offset'] = 0;
      newData['customClass'] =
        newData['showClose'] && newData['showClose'] == true
          ? ' notification-show-close'
          : ' notification-without-close';
      if (newData['notificationType'] == 'notification-link') {
        newData['customClass'] = newData['customClass'] + ' notification-link';
      }
      newData['dangerouslyUseHTMLString'] = true;
      if (newData.button.length == 1) {
        newData[
          'message'
        ] = `<p class="notification-text">${newData.message}</p>
      <div style="display: flex">
      <a href="${newData.button[0].link}" target="_blank" class="link-button">${newData.button[0].text}</a>
      </div>`;
      } else if (newData.button.length == 2) {
        newData[
          'message'
        ] = `<p class="notification-text">${newData.message}</p>
        <div style="display: flex">
        <a href="${newData.button[0].link}" target="_blank" class="link-button">${newData.button[0].text}</a>
        <a href="${newData.button[1].link}" target="_blank" style="margin-left:40px" class="link-button">${newData.button[1].text}</a>
        </div>`;
      }
      if (data.type) {
        newData['customClass'] += ` el-notification--${data.type}`;
      }

      Notification(newData);
    },
    showErrorMessage(errors, params = {}) {
      if (!errors) return;

      const showError = (err, data = {}) => {
        const errObj = this.errorText(
          err.message || err.title || err?.error_text || err,
          data
        );
        if (errObj.msg.indexOf('<br>') >= 0) {
          this.showMultiTextNotification({
            offset: 80,
            showClose: true,
            messageArray: [errObj.msg],
            duration: 15000,
            type: errObj.type,
            title: 'Ошибка',
            message: ''
          });
        } else {
          this.showNotification({
            offset: 80,
            showClose: true,
            message: errObj.msg,
            duration: 15000,
            type: errObj.type,
            customClass: errObj.className || ''
          });
        }
      };

      if (Array.isArray(errors)) {
        errors.forEach(err => showError(err, params));
      } else {
        showError(errors, params);
      }
    },
    errorText(err, data = {}) {
      let obj = { msg: err, type: 'error', ...data };

      if (err === 'permission denied') {
        obj.msg =
          'У Вас нет доступа к данному действию. Свяжитесь с вашим системным администратором для получения соответствующих прав.';
      } else if (err === 'USERNAME_INVALID') {
        obj = {
          msg: 'Указан неверный логин Telegram. Попробуйте другой канал связи.',
          type: 'warning'
        };
      } else if (
        err === 'This peer is not present in the internal peer database' ||
        err == 'No user peer'
      ) {
        obj = {
          msg: 'Кандидат еще не зарегистрирован в Telegram. Попробуйте другой канал связи.',
          type: 'warning'
        };
      } else if (err === 'user has no telegram peer') {
        obj.msg =
          'Ошибка. Проверьте настройки синхронизации с Telegram в профиле';
      } else if (err === 'token error') {
        obj.msg = 'Ошибка токена';
      } else if (err === 'unknown error') {
        obj.msg =
          'Неизвестная ошибка! Вероятно, под Вашей учетной записью нельзя публиковать вакансии. Скорректируйте настройки учетной записи на работном сайте и повторите попытку.';
      } else if (err === 'token expired') {
        obj.msg = 'Токен просрочен';
      } else if (err === 'no or empty work_sites') {
        obj.msg = 'Не передан или пустой обязательный параметр work_sites';
      } else if (err === 'no or empty external_id') {
        obj.msg = 'Не передан или пустой обязательный параметр external_id';
      } else if (err === 'no or empty employer_id') {
        obj.msg = 'Не передан или пустой обязательный параметр employer_id';
      } else if (err === 'no or empty vacancy_id') {
        obj.msg = 'Не передан или пустой обязательный параметр vacancy_id';
      } else if (err === 'no or empty manager_id') {
        obj.msg = 'Не передан или пустой обязательный параметр manager_id';
      } else if (err === 'no or empty resume_id') {
        obj.msg = 'Не передан или пустой обязательный параметр resume_id';
      } else if (err === 'no vacancy found by this external_id') {
        obj.msg =
          'По переденному external_id не найден объект HRPAC_PUBLISHED_VACANCY';
      } else if (err === 'vacancy has no work_site') {
        obj.msg =
          'В найденном объекте HRPAC_PUBLISHED_VACANCY не указан work_site';
      } else if (err === 'unable to prolongate') {
        obj.msg = 'Невозможно пролонгировать опубликованную вакансию';
      } else if (err === 'method not available') {
        obj.msg = 'Метод не реализован или отсутствует для работного сайта';
      } else if (err === 'invalid external_id') {
        obj.msg =
          'переданный external_id (ссылка на вакансию) не соответствует формату выбранного работного сайта';
      } else if (err === 'invalid employer id') {
        obj.msg =
          'employer id импортируемой вакансии не соответствует employer id ни у одного авторизированного пользователя';
      } else if (err === 'no token') {
        obj.msg = 'На авторизационном сервисе нет токена';
      } else if (err === 'code exprired') {
        obj.msg = 'Истек срок годности code для авторизации';
      } else if (err === 'not found') {
        obj.msg = 'Не найдено (вакансия, резюме и т.д.)';
      } else if (err === 'validation error') {
        obj.msg = 'Переданы неверные параметры';
      } else if (err === 'access denied') {
        obj.msg = 'Ограничен доступ на совершение действия';
      } else if (err === 'app key required') {
        obj.msg = 'Необходимо передать ключ приложения';
      } else if (err === 'app not found') {
        obj.msg = 'Неверный ключ приложения';
      } else if (
        err === 'Path not found' ||
        err.split('\\').join('') ===
          'No sessions available. Call /system/addSession?session=%session_name% or restart server with --session option'
      ) {
        obj = {
          msg: 'Отсутствует настройка связи с Telegram. Создайте сессию в настройках профиля',
          type: 'warning'
        };
        setTimeout(() => this.showAuthForm(), 1000);
      } else if (err.indexOf('Session not found') > -1) {
        // err === 'Path not found' ||
        obj.msg =
          'Отсутствует настройка связи с Telegram. Пройдите повторную авторизацию';
        setTimeout(() => this.showAuthForm(), 1000);
      } else if (err === 'PHONE_NUMBER_INVALID') {
        obj.msg = 'Введите корректно номер телефона!';
        obj.className = 'el-message--telegram';
      } else if (err === 'AUTH_KEY_UNREGISTERED') {
        obj.msg =
          'Отсутствует настройка связи с Telegram. Пройдите повторную авторизацию';
        setTimeout(() => this.showAuthForm(), 1000);
      }
      return obj;
    },
    showFullNotification(data = {}) {
      Notification(data);
    }
  }
};

export const detailViewPage = {
  methods: {
    getEnumFieldName(fieldName) {
      if (!this.fields[fieldName]) return null;

      const id = this.fields[fieldName].value;
      const options = this.fields[fieldName].options;
      return options[id];
    }
  }
};

export const callNotifications = {
  data() {
    return {
      intervalNotifications: null
    };
  },
  computed: {
    newNotifications() {
      const newNotifications =
        store.state.notifications?.notifications?.data?.data?.data?.rows || [];
      const readed = store.state.notifications?.readed;
      if (newNotifications.length) {
        return newNotifications?.filter(
          item => !readed.includes(item.ID) && item.IS_READ == 0
        );
      }
      return newNotifications;
    }
  },
  async created() {
    eventBus.$on(EVENTBUS_EVENTS.FETCH_NOTIFICATIONS, async () => {
      await store.dispatch('notifications/fetchNotifications');
    });
    eventBus.$on(EVENTBUS_EVENTS.FETCH_NEW_NOTIFICATIONS, async () => {
      await store.dispatch('notifications/fetchNewNotifications');
    });

    if (!localStorage.getItem('timestamp')) {
      localStorage.setItem('timestamp', Date.now());
    }

    eventBus.$emit(EVENTBUS_EVENTS.FETCH_NEW_NOTIFICATIONS);
    if (
      !window.location.href.includes('/notifications') &&
      localStorage.getItem('auth') === 'true'
    ) {
      eventBus.$emit(EVENTBUS_EVENTS.FETCH_NOTIFICATIONS);
    }

    store.commit('notifications/setParam', {
      name: 'readedPush',
      val: JSON.parse(localStorage.getItem('readedPushNotifications')) ?? []
    });

    if (localStorage.getItem('auth') === 'true') {
      this.updateNotifications(true);
    }
  },
  watch: {
    newNotifications: {
      handler(value) {
        this.setFavicon(value);
      },
      immediate: true
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalNotifications);
    eventBus.$off(EVENTBUS_EVENTS.FETCH_NOTIFICATIONS);
    eventBus.$off(EVENTBUS_EVENTS.FETCH_NEW_NOTIFICATIONS);
  },
  methods: {
    updateNotifications(value) {
      if (value) {
        this.intervalNotifications = setInterval(async () => {
          const timestamp = localStorage.getItem('timestamp');
          if (Date.now() - timestamp > 15000) {
            localStorage.setItem('timestamp', Date.now());
            const oldPushQuery =
              store.state.notifications?.newNotifications ?? [];
            eventBus.$emit(EVENTBUS_EVENTS.FETCH_NEW_NOTIFICATIONS);
            if (
              oldPushQuery !== store.state.notifications?.newNotifications ??
              []
            ) {
              eventBus.$emit(EVENTBUS_EVENTS.FETCH_NOTIFICATIONS);
            }
          }
        }, 15000);
      } else {
        clearInterval(this.intervalNotifications);
      }
    },
    setFavicon(value) {
      const linkIcon = document.querySelector("link[rel~='icon']#icon");
      const linkAppleTouchIcon = document.querySelector(
        "link[rel~='apple-touch-icon'"
      );
      const linkIcon32 = document.querySelector("link[rel~='icon']#icon32");
      const linkIcon16 = document.querySelector("link[rel~='icon']#icon16");
      const linkManifest = document.querySelector("link[rel~='manifest'");

      if (value?.length) {
        const changeHref = (href, format) =>
          href?.includes(`-dot.${format}`)
            ? href
            : href.replace(`.${format}`, `-dot.${format}`);

        if (linkIcon) {
          linkIcon.href = changeHref(linkIcon.href, 'ico');
        }
        if (linkAppleTouchIcon) {
          linkAppleTouchIcon.href = changeHref(linkAppleTouchIcon.href, 'png');
        }
        if (linkIcon32) {
          linkIcon32.href = changeHref(linkIcon32.href, 'png');
        }
        if (linkIcon16) {
          linkIcon16.href = changeHref(linkIcon16.href, 'png');
        }
        if (linkManifest) {
          linkManifest.href = linkManifest.href?.includes('-dot')
            ? linkManifest.href
            : linkManifest.href + '-dot';
        }
      } else {
        const changeHref = href =>
          href?.includes('-dot') ? href.replace('-dot', '') : href;

        if (linkIcon) {
          linkIcon.href = changeHref(linkIcon.href);
        }
        if (linkAppleTouchIcon) {
          linkAppleTouchIcon.href = changeHref(linkAppleTouchIcon.href);
        }
        if (linkIcon32) {
          linkIcon32.href = changeHref(linkIcon32.href);
        }
        if (linkIcon16) {
          linkIcon16.href = changeHref(linkIcon16.href);
        }
        if (linkManifest) {
          linkManifest.href = changeHref(linkManifest.href);
        }
      }
    }
  }
};
